(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-benefit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-benefit-coupon')) {
    customElements.define('bf-benefit-coupon', class extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('[data-bfb-copy]')) {
          this.initialize();
        } else {
          this.initFrame = requestAnimationFrame(() => this.initialize());
        }
      }
      initialize() {
        if (!this.isConnected) return;
        this.button = this.querySelector('[data-bfb-copy]');
        if (!this.button) return;
        this.label = this.querySelector('[data-bfb-copy-label]');
        this.status = this.querySelector('[data-bfb-status]');
        this.originalLabel = this.button.dataset.label || this.label.textContent;
        this.label.textContent = this.originalLabel;
        this.handleCopy = this.copy.bind(this);
        this.button.addEventListener('click', this.handleCopy);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        clearTimeout(this.resetTimer);
        if (this.button) this.button.removeEventListener('click', this.handleCopy);
        if (this.label) this.label.textContent = this.originalLabel;
        if (this.status) this.status.textContent = '';
      }
      legacyCopy(code) {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0';
        document.body.appendChild(field);
        let copied = false;
        try {
          field.select();
          copied = document.execCommand('copy');
        } finally {
          field.remove();
        }
        return copied;
      }
      async copy() {
        const code = this.button.dataset.code;
        if (!code || this.button.disabled) return;
        clearTimeout(this.resetTimer);
        this.label.textContent = this.originalLabel;
        this.status.textContent = '';
        const previousFocus = document.activeElement;
        this.button.disabled = true;
        let copied = false;
        let usedLegacy = false;
        const fallback = () => { usedLegacy = true; return this.legacyCopy(code); };
        try {
          if (navigator.clipboard && window.isSecureContext) {
            try {
              await navigator.clipboard.writeText(code);
              copied = true;
            } catch (_) { copied = fallback(); }
          } else { copied = fallback(); }
        } catch (_) { copied = false; }
        if (!this.isConnected) { this.button.disabled = false; return; }
        this.button.disabled = false;
        if (usedLegacy || (previousFocus === this.button && document.activeElement === document.body)) {
          this.button.focus({ preventScroll: true });
        }
        if (copied) {
          this.label.textContent = this.button.dataset.copied || 'Copied!';
          this.status.textContent = this.label.textContent;
          this.resetTimer = setTimeout(() => {
            this.label.textContent = this.originalLabel;
            this.status.textContent = '';
          }, 2500);
        } else {
          this.label.textContent = this.button.dataset.manual || 'Select code';
          this.status.textContent = this.button.dataset.error || 'Please select and copy the code above.';
          const codeText = this.querySelector('[data-bfb-code-text]');
          const selection = window.getSelection();
          if (codeText && selection) {
            const range = document.createRange();
            range.selectNodeContents(codeText);
            selection.removeAllRanges();
            selection.addRange(range);
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-free-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-free-order')) {
    class BFFreeOrder extends HTMLElement {
      static scrollOwners = new Set();
      static previousOverflow = '';
      static previousOverflowPriority = '';

      connectedCallback() {
        this.onClick = this.handleClick.bind(this);
        this.onClose = this.handleClose.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('close', this.onClose, true);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('close', this.onClose, true);
        const dialog = this.querySelector('dialog');
        if (dialog && dialog.open) dialog.close();
        this.unlockScroll();
        this.opener = null;
      }

      handleClick(event) {
        const dialog = this.querySelector('dialog');
        if (!dialog) return;
        const opener = event.target.closest('[data-rules-open]');
        if (opener) {
          if (dialog.open || opener.disabled) return;
          this.opener = opener;
          dialog.showModal();
          this.lockScroll();
          return;
        }
        if (event.target.closest('[data-rules-close]')) {
          dialog.close();
          return;
        }
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
      }

      handleClose(event) {
        if (!event.target.matches('.bffo__dialog') || event.target.open) return;
        this.unlockScroll();
        if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }

      lockScroll() {
        const owners = BFFreeOrder.scrollOwners;
        if (owners.has(this)) return;
        if (owners.size === 0) {
          const style = document.documentElement.style;
          BFFreeOrder.previousOverflow = style.getPropertyValue('overflow');
          BFFreeOrder.previousOverflowPriority = style.getPropertyPriority('overflow');
          style.setProperty('overflow', 'hidden', 'important');
        }
        owners.add(this);
      }

      unlockScroll() {
        const owners = BFFreeOrder.scrollOwners;
        if (!owners.delete(this) || owners.size > 0) return;
        const style = document.documentElement.style;
        if (BFFreeOrder.previousOverflow) {
          style.setProperty('overflow', BFFreeOrder.previousOverflow, BFFreeOrder.previousOverflowPriority);
        } else {
          style.removeProperty('overflow');
        }
      }
    }
    customElements.define('bf-free-order', BFFreeOrder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sihoo-eu-bf-grid')) {
    customElements.define('sihoo-eu-bf-grid', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const tabs = Array.from(this.querySelectorAll('[data-series-tab]'));
        const panels = Array.from(this.querySelectorAll('[data-series-panel]'));
        const descElement = this.querySelector('[data-series-description]');
        const activate = (series, focus = false) => {
          tabs.forEach(tab => {
            const selected = tab.dataset.seriesTab === series;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            if (selected && focus) tab.focus();
          });
          panels.forEach(panel => { panel.hidden = panel.dataset.seriesPanel !== series; });
          if (descElement) {
            const description = tabs.find(tab => tab.dataset.seriesTab === series)?.dataset.tabDescription || '';
            descElement.textContent = description;
            descElement.hidden = !description;
          }
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab.dataset.seriesTab), options);
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 :
              (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            activate(tabs[next].dataset.seriesTab, true);
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const selectedTabBlock = event.target.closest('[data-series-tab]');
          if (selectedTabBlock) { activate(selectedTabBlock.dataset.seriesTab); return; }
          const card = event.target.closest('[data-sebf-card]');
          const panel = card?.closest('[data-series-panel]');
          if (panel) activate(panel.dataset.seriesPanel);
        }, options);

        this.querySelectorAll('[data-sebf-card]').forEach(card => {
          const data = document.getElementById(card.dataset.productDataId || '');
          if (!data) return;
          let product;
          try { product = JSON.parse(data.textContent); } catch (_) { return; }
          if (!Array.isArray(product?.variants) || !product.variants.length) return;
          card._sebfProduct = product;
          const selector = card.querySelector('[data-sebf-variant-select]');
          if (selector) {
            selector.addEventListener('change', () => this.updateCard(card, true), options);
          }
          this.updateCard(card, false);
        });
        this.addEventListener('click', event => {
          const checkoutButton = event.target.closest('[data-sebf-checkout]');
          if (!checkoutButton || !this.contains(checkoutButton)) return;
          event.preventDefault();
          if (!checkoutButton.disabled) this.handleCheckout(checkoutButton);
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      updateCard(card, changeImage) {
        const product = card._sebfProduct;
        if (!product) return;
        const selector = card.querySelector('[data-sebf-variant-select]');
        const variantId = selector?.value || card.querySelector('[data-sebf-variant-id]')?.value;
        const variant = product.variants.find(item => String(item.id) === String(variantId));
        if (!variant) return;
        card._sebfVariant = variant;
        const variantInput = card.querySelector('[data-sebf-variant-id]');
        const price = card.querySelector('[data-sebf-price]');
        const compare = card.querySelector('[data-sebf-compare]');
        const badge = card.querySelector('[data-sebf-badge]');
        const badgeNumber = card.querySelector('[data-sebf-badge-number]');
        const add = card.querySelector('[data-sebf-add]');
        const checkout = card.querySelector('[data-sebf-checkout]');
        const error = card.querySelector('[data-sebf-error]');
        if (variantInput) variantInput.value = String(variant.id);
        if (price) price.textContent = variant.price_formatted || '';
        if (compare) {
          compare.textContent = variant.compare_formatted || '';
          compare.hidden = !variant.compare_formatted;
        }
        if (badge) {
          badge.hidden = !variant.badge_show;
          badge.setAttribute('aria-label', `${variant.badge_text || ''} OFF`);
        }
        if (badgeNumber) badgeNumber.textContent = variant.badge_text || '';
        if (add) {
          add.disabled = !variant.available;
          add.textContent = variant.available ? (this.dataset.addLabel === 'Quick Add' ? 'Add to Cart' : this.dataset.addLabel || 'Add to Cart') : (this.dataset.soldOutLabel || 'Sold Out');
        }
        if (checkout) checkout.disabled = !variant.available;
        if (error) { error.textContent = ''; error.hidden = true; }

        // Maintain the selected variant on every product-detail link, including image and title.
        let url;
        try {
          url = new URL(product.url, window.location.origin);
          url.searchParams.set('variant', String(variant.id));
        } catch (_) { url = null; }
        if (url) card.querySelectorAll('[data-sebf-product-link]').forEach(link => {
          link.href = url.pathname + url.search + url.hash;
        });
        if (!changeImage) return; // Preserve merchant image overrides until a shopper changes SKU.
        const image = card.querySelector('.sebf__image');
        if (!image) return;
        const image900 = variant.image_900 || product.default_image_900;
        const image700 = variant.image_700 || product.default_image_700;
        const image450 = variant.image_450 || product.default_image_450;
        if (!image900) return;
        const source = card.querySelector('[data-sebf-picture-source]');
        if (source) source.srcset = `${image450 || image900} 450w, ${image700 || image900} 700w`;
        image.src = image900;
        image.srcset = `${image450 || image900} 450w, ${image700 || image900} 700w, ${image900} 900w`;
        image.alt = product.title + (variant.title && variant.title !== 'Default Title' ? ` - ${variant.title}` : '');
      }

      async handleCheckout(button) {
        const card = button.closest('[data-sebf-card]');
        const variant = card?._sebfVariant;
        const form = button.closest('form');
        if (!form || !variant?.available || button.dataset.busy === 'true') return;
        button.dataset.busy = 'true';
        const add = card.querySelector('[data-sebf-add]');
        const selector = card.querySelector('[data-sebf-variant-select]');
        const error = card.querySelector('[data-sebf-error]');
        const originalLabel = button.textContent;
        button.textContent = 'Processing...';
        button.disabled = true;
        if (add) add.disabled = true;
        if (selector) selector.disabled = true;
        if (error) { error.textContent = ''; error.hidden = true; }
        try {
          // Match FoxTheme's AJAX FormData approach while avoiding an unnecessary cart drawer.
          // Do not redirect unless Shopify confirms that the selected variant was added.
          const response = await fetch(window.FoxTheme?.routes?.cart_add_url || this.dataset.cartAddUrl || '/cart/add', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok || result.status || result.errors) {
            throw new Error(result.description || result.message || 'Unable to add this product.');
          }
          window.location.assign(this.dataset.checkoutUrl || '/checkout');
        } catch (err) {
          if (error) {
            error.textContent = err?.message || 'Unable to add this product. Please try again.';
            error.hidden = false;
          }
        } finally {
          button.dataset.busy = 'false';
          button.textContent = originalLabel;
          if (selector) selector.disabled = false;
          if (add) add.disabled = !variant.available;
          button.disabled = !variant.available;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-trustpilot"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bf-trustpilot')) return;

    class BFTrustpilot extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), {
            once: true,
            signal: this.controller.signal
          });
        } else this.initialize();
      }

      initialize() {
        if (!this.isConnected || !this.controller) return;
        const signal = this.controller.signal;
        this.viewport = this.querySelector('[data-bftp-viewport]');
        this.cards = Array.from(this.querySelectorAll('[data-bftp-review]'));
        this.previous = this.querySelector('[data-bftp-previous]');
        this.next = this.querySelector('[data-bftp-next]');
        this.position = this.querySelector('[data-bftp-position]');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = 0;

        const hideBrokenAvatar = (image) => {
          if (image instanceof HTMLImageElement && image.classList.contains('bftp__avatar-image')) image.hidden = true;
        };
        this.addEventListener('error', (event) => hideBrokenAvatar(event.target), { capture: true, signal });
        this.querySelectorAll('.bftp__avatar-image').forEach((image) => {
          if (image.complete && image.naturalWidth === 0) hideBrokenAvatar(image);
        });
        if (!this.viewport || this.cards.length < 2) return;

        this.classList.add('is-enhanced');
        this.previous.addEventListener('click', () => this.goTo(this.activeIndex - 1), { signal });
        this.next.addEventListener('click', () => this.goTo(this.activeIndex + 1), { signal });
        this.viewport.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.readPosition());
        }, { passive: true, signal });
        this.viewport.addEventListener('keydown', (event) => {
          if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.goTo(this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          if (!event.detail) return;
          const index = this.cards.findIndex((card) => card.dataset.blockId === String(event.detail.blockId));
          if (index >= 0) this.goTo(index, true);
        }, { signal });
        this.mobile.addEventListener('change', () => this.align(), { signal });
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.align());
        });
        this.resizeObserver.observe(this.viewport);
        this.readPosition();
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
        if (this.resizeObserver) this.resizeObserver.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.classList.remove('is-enhanced');
      }

      offsetFor(index) {
        const offset = this.cards[index].offsetLeft - this.cards[0].offsetLeft;
        return Math.min(offset, this.viewport.scrollWidth - this.viewport.clientWidth);
      }

      goTo(index, instant = false) {
        if (!this.mobile.matches) return;
        const target = Math.max(0, Math.min(this.cards.length - 1, index));
        this.viewport.scrollTo({
          left: this.offsetFor(target),
          behavior: instant || this.reducedMotion.matches ? 'auto' : 'smooth'
        });
        this.activeIndex = target;
        this.updateControls();
      }

      align() {
        if (this.mobile.matches) this.goTo(this.activeIndex, true);
        else {
          this.viewport.scrollLeft = 0;
          this.activeIndex = 0;
          this.updateControls();
        }
      }

      readPosition() {
        if (!this.mobile.matches) return;
        let index = 0;
        let nearest = Infinity;
        this.cards.forEach((card, candidate) => {
          const distance = Math.abs(this.offsetFor(candidate) - this.viewport.scrollLeft);
          if (distance < nearest) { nearest = distance; index = candidate; }
        });
        this.activeIndex = index;
        this.updateControls();
      }

      updateControls() {
        this.previous.disabled = this.activeIndex === 0;
        this.next.disabled = this.activeIndex === this.cards.length - 1;
        this.position.textContent = `${String(this.activeIndex + 1).padStart(2, '0')} / ${String(this.cards.length).padStart(2, '0')}`;
      }
    }

    customElements.define('bf-trustpilot', BFTrustpilot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('de-bf-v2-quick-buy')) {
    customElements.define('de-bf-v2-quick-buy', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.mobileQuery = window.matchMedia('(max-width: 768.98px)');
        this.posterWarmupReached = false;
        this.videoPlaybackTokens = new WeakMap();
        this.posterDecodePromises = new WeakMap();
        this.decodedPosters = new WeakSet();
        this.panels = Array.from(this.querySelectorAll('[data-desktop-panel]'));
        this.accordion = this.querySelector('[data-accordion]');
        this.accordionItems = Array.from(this.querySelectorAll('[data-accordion-item]'));
        this.desktopHotspots = Array.from(this.querySelectorAll('[data-desktop-hotspot]'));
        this.mobileHotspots = Array.from(this.querySelectorAll('[data-mobile-hotspot]'));
        this.back = this.querySelector('[data-cover-button]');
        this.status = this.querySelector('[data-status]');
        this.desktopCurrent = null;
        this.lastDesktopTrigger = null;
        this.lastMobileTrigger = null;
        this.modal = document.getElementById(this.dataset.modalId);
        if (this.modal) {
          this.modalPanel = this.modal.querySelector('[data-modal-panel]');
          this.modalScroll = this.modal.querySelector('[data-modal-scroll]');
          this.modalFeatures = Array.from(this.modal.querySelectorAll('[data-modal-feature]'));
          this.modalCount = this.modal.querySelector('[data-modal-count]');
          this.modalCurrent = null;
          this.availableMobile = this.mobileHotspots.filter(button => !button.disabled).map(button => button.dataset.blockId);
          this.modal.querySelector('[data-modal-prev]')?.addEventListener('click', () => this.stepModal(-1), opts);
          this.modal.querySelector('[data-modal-next]')?.addEventListener('click', () => this.stepModal(1), opts);
          this.modal.querySelector('[data-modal-close]')?.addEventListener('click', () => this.closeModal(), opts);
          this.modal.addEventListener('click', event => {
            if (event.target !== this.modal) return;
            const box = this.modalPanel?.getBoundingClientRect();
            if (!box || event.clientX < box.left || event.clientX > box.right ||
              event.clientY < box.top || event.clientY > box.bottom) this.closeModal();
          }, opts);
          this.modal.addEventListener('cancel', event => {
            event.preventDefault();
            this.closeModal();
          }, opts);
          this.modal.addEventListener('close', () => this.afterModalClose(), opts);
          this.modal.addEventListener('keydown', event => {
            if (!this.modal.open) return;
            if (event.key === 'Escape') {
              event.stopPropagation();
              return;
            }
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
            event.stopPropagation();
            event.preventDefault();
            this.stepModal(event.key === 'ArrowRight' ? 1 : -1);
          }, opts);

          let touchStart = null;
          this.modalScroll?.addEventListener('touchstart', event => {
            if (event.touches.length !== 1 || event.target.closest('video, a, button')) {
              touchStart = null;
              return;
            }
            touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
          }, { ...opts, passive: true });
          this.modalScroll?.addEventListener('touchend', event => {
            if (!touchStart || !event.changedTouches.length) return;
            const dx = event.changedTouches[0].clientX - touchStart.x;
            const dy = event.changedTouches[0].clientY - touchStart.y;
            touchStart = null;
            if (Math.abs(dx) >= 55 && Math.abs(dx) > Math.abs(dy) * 1.35) {
              this.stepModal(dx < 0 ? 1 : -1);
            }
          }, { ...opts, passive: true });
          this.modalScroll?.addEventListener('touchcancel', () => { touchStart = null; }, opts);
        }

        this.selectDesktop(null, false);
        this.addEventListener('click', event => {
          const pcHotspot = event.target.closest('[data-desktop-hotspot]');
          if (pcHotspot && !pcHotspot.disabled) {
            this.lastDesktopTrigger = pcHotspot;
            this.selectDesktop(pcHotspot.dataset.blockId);
            this.accordionItems.find(item => item.dataset.blockId === pcHotspot.dataset.blockId)
              ?.querySelector('[data-accordion-button]')?.focus({ preventScroll: true });
            return;
          }
          const accordionButton = event.target.closest('[data-accordion-button]');
          if (accordionButton && !accordionButton.disabled) {
            // Selecting an already-open detail keeps it open. Use Back to overview to close.
            this.selectDesktop(accordionButton.dataset.blockId);
            return;
          }
          if (event.target.closest('[data-cover-button]')) {
            this.returnToCover();
            return;
          }
          const mobileHotspot = event.target.closest('[data-mobile-hotspot]');
          if (mobileHotspot && !mobileHotspot.disabled) this.openModal(mobileHotspot.dataset.blockId, mobileHotspot);
        }, opts);

        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.desktopCurrent && !this.mobileQuery.matches) {
            event.preventDefault();
            this.returnToCover();
            return;
          }
          const button = event.target.closest('[data-accordion-button]');
          if (!button || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          const enabled = Array.from(this.querySelectorAll('[data-accordion-button]:not(:disabled)'));
          const index = enabled.indexOf(button);
          if (index < 0 || !enabled.length) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = enabled.length - 1;
          else nextIndex = (index + (event.key === 'ArrowDown' ? 1 : -1) + enabled.length) % enabled.length;
          enabled[nextIndex].focus();
          this.selectDesktop(enabled[nextIndex].dataset.blockId);
        }, opts);

        this.addEventListener('shopify:block:select', event => {
          const blockId = event.detail?.blockId;
          if (!blockId || !this.panels.some(panel => panel.dataset.blockId === blockId)) return;
          if (this.mobileQuery.matches) {
            const trigger = this.mobileHotspots.find(button => button.dataset.blockId === blockId);
            if (trigger && !trigger.disabled) this.openModal(blockId, trigger);
          } else {
            this.selectDesktop(blockId);
          }
        }, opts);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauseAllVideos();
        }, opts);
        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', () => {
            if (!this.mobileQuery.matches) this.closeModal(true);
            else this.selectDesktop(null, false);
            // If the user rotates/resizes after approaching this section, hydrate only
            // the new device layout. Do not request the unused layout in advance.
            if (this.posterWarmupReached) this.preparePostersForCurrentDevice();
          }, opts);
        }
        if ('IntersectionObserver' in window) {
          // Pre-warm CDN still images around 500px before the section.
          // Video URLs remain inert in data-src until the shopper selects a feature.
          this.preloadObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.posterWarmupReached = true;
            this.preparePostersForCurrentDevice();
            this.preloadObserver?.disconnect();
          }, { rootMargin: '500px 0px', threshold: 0 });
          this.preloadObserver.observe(this);

          // Preserve the original behavior: pause desktop video when offscreen.
          this.observer = new IntersectionObserver(entries => {
            if (!entries[0]?.isIntersecting) this.pauseDesktopVideos();
          });
          this.observer.observe(this);
        } else {
          // Older browsers: prepare image posters, but keep video URLs deferred.
          this.posterWarmupReached = true;
          this.preparePostersForCurrentDevice();
        }
      }

      // CDN preview images can be fetched and decoded ahead of use without
      // initializing any video sources. Only the current device's posters are warmed.
      preparePostersForCurrentDevice() {
        const root = this.mobileQuery?.matches ? this.modal : this;
        const device = this.mobileQuery?.matches ? 'mobile' : 'desktop';
        root?.querySelectorAll(`[data-pbv-video="${device}"]`).forEach(video => {
          const image = video.closest('[data-pbv-video-shell]')?.querySelector('.pbv__video-placeholder img');
          this.preparePoster(image);
        });
      }

      // Resolve after the actual image is decoded, rather than merely having
      // a network request in progress. Promise is cached for repeat hotspot visits.
      preparePoster(image) {
        if (!image) return Promise.resolve(false);
        const existing = this.posterDecodePromises.get(image);
        if (existing) return existing;
        image.loading = 'eager';
        image.decoding = 'async';
        const decoded = new Promise(resolve => {
          const finish = loaded => {
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
            if (!loaded) { resolve(false); return; }
            if (typeof image.decode === 'function') {
              image.decode().then(() => resolve(true)).catch(() => resolve(image.naturalWidth > 0));
            } else {
              resolve(true);
            }
          };
          const onLoad = () => finish(image.naturalWidth > 0);
          const onError = () => finish(false);
          if (image.complete) finish(image.naturalWidth > 0);
          else {
            image.addEventListener('load', onLoad, { once: true });
            image.addEventListener('error', onError, { once: true });
          }
        });
        const tracked = decoded.then(ready => {
          if (ready) this.decodedPosters.add(image);
          return ready;
        });
        this.posterDecodePromises.set(image, tracked);
        return tracked;
      }

      // Adapted from ra-video-gallery-01: actual CDN source URLs are stored in
      // data-src and set on <source> elements only on a feature click.
      activateVideoSource(video) {
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        video.removeAttribute('controls');
        if (video.dataset.poster && !video.hasAttribute('poster')) {
          video.setAttribute('poster', video.dataset.poster);
        }
        video.preload = 'auto';
        const deferredSources = video.querySelectorAll('source[data-src]');
        if (!deferredSources.length) return; // Already hydrated. Never call load() again.
        deferredSources.forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
      }

      // Only reveal moving footage once the browser has rendered a real decoded frame.
      // A thumbnail stays visible during buffering, unsupported autoplay and load failures.
      revealOnFirstFrame(video, token) {
        const shell = video.closest('[data-pbv-video-shell]');
        if (!shell) return;
        const reveal = () => {
          if (this.videoPlaybackTokens.get(video) !== token || video.paused || video.readyState < 2) return;
          if (shell.closest('[hidden]') || document.hidden) return;
          shell.classList.add('is-video-ready');
          const panel = video.closest('[data-desktop-panel]');
          if (panel && this.desktopCurrent === panel.dataset.blockId) {
            panel.style.visibility = '';
            this.toggleAttribute('data-feature-media-active', true);
          }
        };
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(reveal);
        } else {
          // Older Safari: wait for actual playback, then allow two paint frames.
          const afterPlayback = () => {
            requestAnimationFrame(() => requestAnimationFrame(reveal));
          };
          video.addEventListener('playing', afterPlayback, { once: true, signal: this.controller.signal });
          video.addEventListener('timeupdate', afterPlayback, { once: true, signal: this.controller.signal });
          if (!video.paused && video.currentTime > 0 && video.readyState >= 2) afterPlayback();
        }
      }

      // Keep the existing overview visible until either the selected item's
      // CDN poster has decoded or its first real video frame has been rendered.
      // This also handles a shopper jumping straight to this section by anchor.
      revealDesktopPanelWithPoster(panel, blockId) {
        const shell = panel?.querySelector('[data-pbv-video-shell]');
        if (!shell) return; // Non-video feature image keeps its original behavior.
        const preview = shell.querySelector('.pbv__video-placeholder img');
        if (preview && this.decodedPosters.has(preview)) return;
        panel.style.visibility = 'hidden';
        this.toggleAttribute('data-feature-media-active', false);
        this.preparePoster(preview).then(ready => {
          if (!ready || this.desktopCurrent !== blockId || panel.hidden) return;
          panel.style.visibility = '';
          this.toggleAttribute('data-feature-media-active', true);
        });
      }

      playVideo(video) {
        if (!video || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const token = (this.videoPlaybackTokens.get(video) || 0) + 1;
        this.videoPlaybackTokens.set(video, token);
        const shell = video.closest('[data-pbv-video-shell]');
        shell?.classList.remove('is-video-ready');
        // A newly opened mobile modal also requests its image first if the
        // section was reached before the 500px preload observer fired.
        this.preparePoster(shell?.querySelector('.pbv__video-placeholder img'));
        this.activateVideoSource(video);
        this.revealOnFirstFrame(video, token);
        const promise = video.play();
        promise?.catch(() => { /* Thumbnail remains visible if playback fails. */ });
      }

      selectDesktop(blockId, announce = true) {
        const panel = this.panels.find(item => item.dataset.blockId === blockId);
        this.pauseDesktopVideos();
        this.desktopCurrent = panel ? blockId : null;
        const hasMedia = Boolean(panel && panel.dataset.hasMedia === 'true');
        this.toggleAttribute('data-feature-active', Boolean(panel));
        this.toggleAttribute('data-feature-media-active', hasMedia);
        this.panels.forEach(item => {
          item.hidden = !hasMedia || item !== panel;
          item.style.visibility = '';
        });
        if (panel && hasMedia) this.revealDesktopPanelWithPoster(panel, blockId);
        if (this.accordion) this.accordion.hidden = !panel;
        if (this.back) this.back.hidden = !panel;
        this.accordionItems.forEach(item => {
          const active = Boolean(panel && item.dataset.blockId === blockId);
          item.classList.toggle('is-active', active);
          const button = item.querySelector('[data-accordion-button]');
          const content = item.querySelector('[data-accordion-description]');
          if (button) button.setAttribute('aria-expanded', String(active));
          if (content) content.hidden = !active;
        });
        if (announce && this.status) {
          const button = this.accordionItems.find(item => item.dataset.blockId === blockId)?.querySelector('[data-accordion-button]');
          this.status.textContent = panel ? (button?.textContent || 'Feature').trim() : 'Back to overview';
        }
        this.playVideo(panel?.querySelector('video'));
      }

      returnToCover() {
        this.selectDesktop(null);
        if (this.lastDesktopTrigger?.isConnected) this.lastDesktopTrigger.focus({ preventScroll: true });
      }

      openModal(blockId, trigger) {
        if (!this.mobileQuery?.matches || !this.modal || !this.availableMobile.includes(blockId)) return;
        if (this.closeTimer) {
          clearTimeout(this.closeTimer);
          this.closeTimer = null;
        }
        const wasOpen = this.modal.open;
        const wasInteractive = this.modal.classList.contains('is-open');
        if (!wasOpen) {
          this.lastMobileTrigger = trigger || null;
          try {
            this.modal.showModal();
          } catch (_) {
            return;
          }
        }
        this.showModalFeature(blockId, 1);
        requestAnimationFrame(() => {
          if (!this.isConnected || !this.modal?.open) return;
          this.modal.classList.add('is-open');
          if (!wasInteractive) this.playVideo(this.modalFeatures?.find(item => item.dataset.blockId === blockId)?.querySelector('video'));
          if (!wasOpen) this.modalPanel?.focus({ preventScroll: true });
        });
      }

      showModalFeature(blockId, direction) {
        const feature = this.modalFeatures?.find(item => item.dataset.blockId === blockId);
        if (!feature) return;
        this.pauseModalVideos();
        this.modalCurrent = blockId;
        this.modal.dataset.direction = direction < 0 ? 'prev' : 'next';
        this.modalFeatures.forEach(item => {
          item.hidden = item !== feature;
          item.classList.remove('is-entering');
        });
        feature.classList.add('is-entering');
        this.modal.setAttribute('aria-labelledby', feature.querySelector('.pbv__modal-title')?.id || '');
        const index = this.availableMobile.indexOf(blockId);
        if (this.modalCount) this.modalCount.textContent = `${index + 1} / ${this.availableMobile.length}`;
        if (this.modalScroll) this.modalScroll.scrollTop = 0;
        if (this.status) this.status.textContent = feature.querySelector('.pbv__modal-title')?.textContent?.trim() || 'Product feature';
        if (this.modal.classList.contains('is-open')) this.playVideo(feature.querySelector('video'));
      }

      stepModal(step) {
        if (!this.modal?.open || !this.availableMobile.length) return;
        const index = this.availableMobile.indexOf(this.modalCurrent);
        const next = (Math.max(0, index) + step + this.availableMobile.length) % this.availableMobile.length;
        this.showModalFeature(this.availableMobile[next], step);
      }

      closeModal(immediate = false) {
        if (!this.modal?.open) return;
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.closeTimer = null;
        this.modal.classList.remove('is-open');
        this.pauseModalVideos();
        const finish = () => {
          this.closeTimer = null;
          if (this.modal?.open) this.modal.close();
        };
        if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
        else this.closeTimer = window.setTimeout(finish, 180);
      }

      afterModalClose() {
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.closeTimer = null;
        this.modal?.classList.remove('is-open');
        this.pauseModalVideos();
        const trigger = this.lastMobileTrigger;
        if (trigger?.isConnected && this.mobileQuery?.matches) trigger.focus({ preventScroll: true });
        this.lastMobileTrigger = null;
        this.modalCurrent = null;
      }

      pauseVideo(video) {
        this.videoPlaybackTokens?.set(video, (this.videoPlaybackTokens.get(video) || 0) + 1);
        video.pause();
      }
      pauseDesktopVideos() { this.panels?.forEach(panel => panel.querySelectorAll('video').forEach(video => this.pauseVideo(video))); }
      pauseModalVideos() { this.modal?.querySelectorAll('video').forEach(video => this.pauseVideo(video)); }
      pauseAllVideos() { this.pauseDesktopVideos(); this.pauseModalVideos(); }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.preloadObserver?.disconnect();
        this.pauseAllVideos();
        if (this.modal?.open) this.modal.close();
        this.modal?.classList.remove('is-open');
        document.getElementById(this.dataset.quickBuyId || '')?.remove();
      }
    });
  }

  if (!customElements.get('de-bf-v2-quick-buy-drawer')) {
    class PreBfQuickBuy extends HTMLElement {
      connectedCallback() {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }
        if (this._initialized) return;
        this._initialized = true;
        this._controller = new AbortController();
        const opts = { signal: this._controller.signal };
        this._panel = this.querySelector('[data-pbq-panel]');
        this._title = this.querySelector('[data-pbq-title]');
        this._image = this.querySelector('[data-pbq-image]');
        this._priceRow = this.querySelector('[data-pbq-price-row]');
        this._price = this.querySelector('[data-pbq-price]');
        this._comparePrice = this.querySelector('[data-pbq-compare-price]');
        this._options = this.querySelector('[data-pbq-options]');
        this._status = this.querySelector('[data-pbq-status]');
        this._checkoutButton = this.querySelector('[data-pbq-checkout]');
        this._addButton = this.querySelector('[data-pbq-add]');
        this._success = this.querySelector('[data-pbq-success]');
        this._successProduct = this.querySelector('[data-pbq-success-product]');
        this._onDocumentClick = (event) => {
          const trigger = event.target.closest?.('[data-pbq-trigger]');
          if (!trigger || trigger.dataset.pbqDrawerId !== this.id) return;
          const dataNode = document.getElementById(trigger.dataset.pbqProductDataId || '');
          if (!dataNode) return;
          try {
            this.product = JSON.parse(dataNode.textContent || '{}');
          } catch (error) {
            this._setStatus('Product options could not be loaded. Please try again.', true);
            return;
          }
          if (!this.product || !Array.isArray(this.product.variants) || !this.product.variants.length) {
            this._setStatus('This product has no selectable variants.', true);
            return;
          }
          this.opener = trigger;
          this.initialVariantId = trigger.dataset.pbqInitialVariantId || '';
          this._renderProduct();
          this.open();
        };
        this._onClick = (event) => {
          if (event.target.closest?.('[data-pbq-close]')) {
            event.preventDefault();
            this.close();
            return;
          }
          const optionButton = event.target.closest?.('[data-pbq-option-index]');
          if (optionButton && this.contains(optionButton)) {
            const index = Number(optionButton.dataset.pbqOptionIndex);
            this.selectedOptions[index] = optionButton.dataset.pbqOptionValue;
            this._renderOptions();
            this._syncVariant();
            return;
          }
          if (event.target.closest?.('[data-pbq-add]')) {
            event.preventDefault();
            this._addToCart();
            return;
          }
          if (event.target.closest?.('[data-pbq-checkout]')) {
            event.preventDefault();
            this._checkoutSelectedVariant();
            return;
          }
        };
        this._onKeydown = (event) => {
          if (!this._isOpen) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }
          if (event.key !== 'Tab') return;
          const focusable = Array.from(this._panel.querySelectorAll('a[href]:not([hidden]), button:not(:disabled):not([hidden]), [tabindex]:not([tabindex="-1"]):not([hidden])'))
            .filter((node) => node.getAttribute('aria-hidden') !== 'true');
          if (!focusable.length) {
            event.preventDefault();
            this._panel.focus();
            return;
          }
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        };
        document.addEventListener('click', this._onDocumentClick, opts);
        document.addEventListener('keydown', this._onKeydown, opts);
        this.addEventListener('click', this._onClick, opts);
      }

      disconnectedCallback() {
        this._controller?.abort();
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this._initialized = false;
      }

      open() {
        this._resetSuccess();
        document.querySelectorAll('de-bf-v2-quick-buy-drawer.is-open').forEach((drawer) => {
          if (drawer !== this && typeof drawer.close === 'function') drawer.close(false);
        });
        // Close Sleek's native cart drawer only if it is currently open.
        const nativeCartDrawer = document.querySelector('cart-drawer[open]');
        if (nativeCartDrawer && typeof nativeCartDrawer.hide === 'function') nativeCartDrawer.hide();
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this.hidden = false;
        this.setAttribute('aria-hidden', 'false');
        this._isOpen = true;
        requestAnimationFrame(() => this.classList.add('is-open'));
        requestAnimationFrame(() => this.querySelector('[data-pbq-close]')?.focus({ preventScroll: true }));
      }

      close(restoreFocus = true) {
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this._closeTimer = null;
        this._resetSuccess();
        if (!this._isOpen) return;
        this._isOpen = false;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        this._closeTimer = setTimeout(() => {
          if (!this._isOpen) this.hidden = true;
          this._closeTimer = null;
        }, 230);
        if (restoreFocus && this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }

      _renderProduct() {
        this._resetSuccess();
        this._title.textContent = this.product.title || 'Choose a product';
        this._status.textContent = '';
        this._status.classList.remove('is-error');
        const initial = this.product.variants.find((variant) => String(variant.id) === String(this.initialVariantId));
        const variant = initial || this.product.variants.find((item) => item.available) || this.product.variants[0];
        this.selectedOptions = Array.isArray(variant.options) ? [...variant.options] : [];
        this.currentVariant = variant;
        this._renderOptions();
        this._syncVariant();
      }

      _renderOptions() {
        this._options.innerHTML = '';
        const optionNames = Array.isArray(this.product.options) ? this.product.options : [];
        const isDefaultTitle = optionNames.length === 1 && String(optionNames[0]).toLowerCase() === 'title';
        if (!optionNames.length || isDefaultTitle) {
          this._options.hidden = true;
          return;
        }
        this._options.hidden = false;
        const anyAvailable = this.product.variants.some((variant) => variant.available);
        optionNames.forEach((optionName, index) => {
          const values = [...new Set(this.product.variants.map((variant) => variant.options?.[index]).filter((value) => typeof value === 'string' && value.length))];
          if (!values.length) return;
          const group = document.createElement('fieldset');
          group.className = 'pbq__option-group';
          const legend = document.createElement('legend');
          legend.className = 'pbq__option-legend';
          legend.textContent = optionName;
          group.appendChild(legend);
          const valueWrap = document.createElement('div');
          valueWrap.className = 'pbq__option-values';
          const isColor = /(?:colou?r|farbe)/i.test(optionName);
          values.forEach((value) => {
            const compatible = this.product.variants.some(variant => variant.available && variant.options?.[index] === value);
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'pbq__option-value';
            if (isColor) button.classList.add('pbq__option-value--color');
            const selected = this.selectedOptions[index] === value;
            if (selected) button.classList.add('is-selected');
            button.setAttribute('aria-pressed', String(selected));
            button.dataset.pbqOptionIndex = String(index);
            button.dataset.pbqOptionValue = value;
            button.textContent = value;
            if (isColor) {
              button.textContent = '';
              const swatch = document.createElement('span');
              swatch.className = 'pbq__swatch';
              swatch.style.backgroundColor = this._colorForValue(value);
              swatch.setAttribute('aria-hidden', 'true');
              const label = document.createElement('span');
              label.textContent = value;
              button.append(swatch, label);
            }
            button.disabled = anyAvailable && !compatible;
            valueWrap.appendChild(button);
          });
          group.appendChild(valueWrap);
          this._options.appendChild(group);
        });
      }

      _colorForValue(value) {
        const normalized = String(value).toLowerCase().trim();
        const colors = {
          black: '#222222', schwarz: '#222222',
          white: '#ffffff', weiss: '#ffffff', 'weiß': '#ffffff',
          grey: '#8c8c8c', gray: '#8c8c8c', grau: '#8c8c8c',
          silver: '#c6c8ca', silber: '#c6c8ca',
          blue: '#3f6fa7', blau: '#3f6fa7', navy: '#1c2c4b', marineblau: '#1c2c4b',
          red: '#b32b2b', rot: '#b32b2b',
          brown: '#76513a', braun: '#76513a',
          beige: '#d8c4a1', cream: '#f3e8d0', creme: '#f3e8d0',
          pink: '#e5a9bd', rosa: '#e5a9bd',
          green: '#497451', gruen: '#497451', 'grün': '#497451',
          purple: '#75559b', lila: '#75559b', violett: '#75559b',
          orange: '#e18a37', yellow: '#f0cf3a', gelb: '#f0cf3a'
        };
        return colors[normalized] || '#bdbdbd';
      }

      _syncVariant() {
        const variant = this.product.variants.find((item) => Array.isArray(item.options) && item.options.length === this.selectedOptions.length && item.options.every((value, index) => value === this.selectedOptions[index]));
        this.currentVariant = variant || null;
        if (variant) {
          const imageUrl = variant.image || this.product.image;
          if (imageUrl) {
            this._image.src = imageUrl;
            this._image.alt = `${this.product.title || ''}${variant.title ? ` - ${variant.title}` : ''}`.trim();
            this._image.hidden = false;
          } else {
            this._image.removeAttribute('src');
            this._image.hidden = true;
          }
        }
        const hasPrice = Boolean(variant && variant.price_formatted);
        this._priceRow.hidden = !hasPrice;
        this._price.textContent = hasPrice ? variant.price_formatted : '';
        const hasComparePrice = Boolean(hasPrice && Number(variant.compare_at_price) > Number(variant.price) && variant.compare_at_price_formatted);
        this._comparePrice.hidden = !hasComparePrice;
        this._comparePrice.textContent = hasComparePrice ? variant.compare_at_price_formatted : '';
        if (!variant) this._setStatus('This option combination is unavailable.', true);
        else if (!variant.available) this._setStatus('This option is sold out. Please choose another option.', true);
        else this._setStatus('', false);
        this._addButton.disabled = !variant || !variant.available || this._adding;
        this._checkoutButton.disabled = !variant || !variant.available || this._adding;
      }

      _checkoutSelectedVariant() {
        const variant = this.currentVariant;
        if (!variant || !variant.available || this._adding) return;
        const variantId = String(variant.id || '');
        if (!/^\d+$/.test(variantId)) {
          this._setStatus('Unable to open checkout for this option. Please try again.', true);
          return;
        }
        // Shopify's native cart permalink opens a dedicated checkout with exactly
        // one unit of the currently selected variant, not other existing cart items.
        // It is locale-aware via the EU storefront's Shopify route.
        const cartRoute = this.dataset.cartUrl || window.FoxTheme?.routes?.cart_url || '/cart';
        const cartPath = new URL(cartRoute, window.location.origin).pathname.replace(/\/+$/, '');
        this._checkoutButton.disabled = true;
        this._checkoutButton.textContent = 'Redirecting...';
        window.location.assign(`${window.location.origin}${cartPath}/${variantId}:1`);
      }

      _setStatus(message, isError = false) {
        if (!this._status) return;
        this._status.textContent = message || '';
        this._status.classList.toggle('is-error', Boolean(isError));
      }

      async _addToCart() {
        const variant = this.currentVariant;
        if (!variant || !variant.available || this._adding) return;
        this._adding = true;
        const originalLabel = this._addButton.textContent;
        this._addButton.disabled = true;
        this._checkoutButton.disabled = true;
        this._addButton.classList.add('is-loading');
        this._addButton.textContent = 'Adding...';
        this._setStatus('', false);
        let added = false;
        let oldCartData = null;
        let refreshedCartData = null;
        const foxTheme = window.FoxTheme || {};
        try {
          const cartUrl = foxTheme.routes?.cart_url || this.dataset.cartUrl || '/cart';
          const cartAddUrl = foxTheme.routes?.cart_add_url || this.dataset.cartAddUrl || '/cart/add';
          const cartJsonUrl = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl.replace(/\/$/, '')}.js`;

          // Keep the existing add/quantity tracking signal while using DE's localized cart route.
          try {
            const oldCartResponse = await fetch(cartJsonUrl, { headers: { Accept: 'application/json' } });
            if (oldCartResponse.ok) oldCartData = await oldCartResponse.json();
          } catch (_) {
            // The cart comparison is optional; adding must remain possible if it fails.
          }

          // Use Sleek's grouped-section hook and its native FormData request contract.
          const sectionsToBundle = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle }
          }));

          const formData = new FormData();
          formData.append('id', String(variant.id));
          formData.append('quantity', '1');
          formData.append('sections', sectionsToBundle.join(','));
          formData.append('sections_url', window.location.pathname);

          const requestConfig = foxTheme.utils?.fetchConfig
            ? foxTheme.utils.fetchConfig('javascript')
            : { method: 'POST', headers: { Accept: 'application/json' } };
          requestConfig.method = 'POST';
          requestConfig.headers = requestConfig.headers || {};
          requestConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete requestConfig.headers['Content-Type'];
          requestConfig.body = formData;

          const response = await fetch(cartAddUrl, requestConfig);
          const data = await response.json();
          let errorMessage = typeof data.description === 'string'
            ? data.description
            : (data.message || 'Unable to add this item. Please try again.');
          if (data.errors && typeof data.errors === 'object') {
            errorMessage = Object.values(data.errors)
              .map(value => Array.isArray(value) ? value.join(', ') : String(value))
              .join(', ');
          }
          if (!response.ok || data.status || data.errors) throw new Error(errorMessage);
          added = true;

          // Refresh DE cart state through FoxTheme's pub/sub API; do not invoke US cart-drawer methods.
          try {
            const cartResponse = await fetch(cartJsonUrl, {
              method: 'GET',
              credentials: 'same-origin',
              headers: { Accept: 'application/json' }
            });
            if (cartResponse.ok) {
              const cartJson = await cartResponse.json();
              if (data.sections) cartJson.sections = data.sections;
              refreshedCartData = cartJson;
              if (foxTheme.pubsub?.publish && foxTheme.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
                foxTheme.pubsub.publish(foxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
              }
            }
          } catch (_) {
            // The add request succeeded; a failed optional cart refresh must not show a false add error.
          }

          const addedVariantId = Number(data.variant_id || variant.id);
          const oldItem = oldCartData?.items?.find(item => Number(item.variant_id) === addedVariantId);
          if (oldItem) {
            this.dispatchEvent(new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                variantId: addedVariantId,
                oldQuantity: oldItem.quantity,
                newQuantity: refreshedCartData?.items?.find(item => Number(item.variant_id) === addedVariantId)?.quantity || oldItem.quantity + 1
              }
            }));
          } else {
            this.dispatchEvent(new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: { variantId: addedVariantId }
            }));
          }
          this.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items: [{ id: addedVariantId, quantity: 1 }] }
          }));
          this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: data } }));
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: data } }));
          this._showSuccessThenClose();
        } catch (error) {
          const message = error?.message || 'Unable to add this item. Please try again.';
          this._setStatus(message, true);
          if (foxTheme.pubsub?.publish && foxTheme.pubsub?.PUB_SUB_EVENTS?.cartError) {
            foxTheme.pubsub.publish(foxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
              source: 'quick-buy',
              productVariantId: variant.id,
              errors: message,
              message
            });
          }
          this.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: { error: message }
          }));
          document.dispatchEvent(new CustomEvent('product-ajax:error', { detail: { errorMessage: message } }));
        } finally {
          this._adding = false;
          this._addButton.classList.remove('is-loading');
          this._addButton.textContent = originalLabel || 'Add to Cart';
          this._addButton.disabled = !this.currentVariant || !this.currentVariant.available;
          this._checkoutButton.disabled = !this.currentVariant || !this.currentVariant.available;
          if (added) this._setStatus('', false);
        }
      }

      _showSuccessThenClose() {
        if (!this._success) {
          this.close();
          return;
        }
        if (this._successProduct) this._successProduct.textContent = this.product?.title || '';
        this._success.hidden = false;
        this._panel.classList.add('has-success');
        this._success.focus({ preventScroll: true });
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this._closeTimer = setTimeout(() => {
          this._closeTimer = null;
          this.close();
        }, 1200);
      }

      _resetSuccess() {
        if (this._success) this._success.hidden = true;
        if (this._panel) this._panel.classList.remove('has-success');
      }
    }
    customElements.define('de-bf-v2-quick-buy-drawer', PreBfQuickBuy);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dhjdtv4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sihoo-highlight-tabs')) return;

    class SihooHighlightTabs extends HTMLElement {
      connectedCallback() {
        if (this.isConnectedOnce) return;
        this.isConnectedOnce = true;

        this.track = this.querySelector('[data-spht-track]');
        this.stickyNav = this.querySelector('[data-spht-sticky-nav]');
        this.navScroller = this.querySelector('[data-spht-nav-scroller]');
        this.tabs = Array.from(this.querySelectorAll('[data-spht-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-spht-panel]'));
        this.videos = Array.from(this.querySelectorAll('video'));
        this.progressFills = Array.from(this.querySelectorAll('[data-spht-progress]'));
        this.autoplaySentinel = this.querySelector('[data-spht-autoplay-sentinel]');
        this.cardRails = Array.from(this.querySelectorAll('[data-spht-card-rail]'));

        if (!this.track || !this.tabs.length || !this.panels.length) return;

        this.abortController = new AbortController();
        this.mobileCardsQuery = window.matchMedia('(max-width: 767px)');
        this.activeIndex = -1;
        this.programmaticIndex = null;
        this.scrollSettleTimer = 0;
        this.autoplayEnabled = this.dataset.autoRotate === 'true'
          && this.panels.length > 1
          && !(window.Shopify && window.Shopify.designMode);
        this.autoplayDuration = Math.min(
          20000,
          Math.max(5000, (Number.parseFloat(this.dataset.rotationInterval) || 8) * 1000)
        );
        this.autoplayElapsed = 0;
        this.autoplayLastTime = 0;
        this.autoplayFrame = 0;
        this.autoplayInteractionTimer = 0;
        this.autoplayManualScrolling = false;
        this.automaticallyPausedVideos = new WeakSet();
        this.automaticallyPlayedVideos = new WeakSet();
        this.videoVisibilityRatios = new WeakMap();
        this.scrollFrame = 0;
        this.heightFrame = 0;
        this.pageScrollFrame = 0;
        this.resizeFrame = 0;

        const signal = this.abortController.signal;
        this.initializeVideos(signal);
        this.initializeCardRails(signal);

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.goTo(index, true, 'manual'), { signal });
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index), { signal });
        });

        this.track.addEventListener('scroll', () => this.onTrackScroll(), { passive: true, signal });
        this.track.addEventListener('scrollend', () => this.onTrackScrollEnd(), { signal });
        this.track.addEventListener('pointerdown', () => this.onTrackInteractionStart(), { passive: true, signal });
        this.track.addEventListener('wheel', (event) => this.onTrackWheel(event), { passive: true, signal });
        window.addEventListener('pointerup', () => this.onTrackInteractionEnd(), { passive: true, signal });
        window.addEventListener('pointercancel', () => this.onTrackInteractionEnd(), { passive: true, signal });
        window.addEventListener('scroll', () => this.schedulePageNavigationSync(), { passive: true, signal });
        window.addEventListener('resize', () => this.onViewportResize(), { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });

        document.addEventListener('visibilitychange', () => {
          this.syncVideos();
        }, { signal });

        if (this.mobileCardsQuery.addEventListener) {
          this.mobileCardsQuery.addEventListener('change', () => {
            this.syncCardRailAccessibility();
            this.syncVideos();
          }, { signal });
        }

        this.resizeObserver = new ResizeObserver((entries) => {
          const activePanel = this.panels[this.activeIndex];
          if (entries.some((entry) => entry.target === activePanel)) {
            this.updateHeight(this.activeIndex);
          }
          this.syncVideos();
          this.schedulePageNavigationSync();
        });

        this.panels.forEach((panel) => this.resizeObserver.observe(panel));

        this.videoVisibilityObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
            this.videoVisibilityRatios.set(entry.target, ratio);
          });
          this.syncVideos();
        }, { threshold: [0, 0.2, 0.55, 0.75] });
        this.videos.forEach((video) => this.videoVisibilityObserver.observe(video));

        this.setActive(0, false);
        requestAnimationFrame(() => {
          this.updateHeight(0);
          this.syncVideos();
          this.syncPageNavigation();
          this.syncCardRailAccessibility();
          this.syncAutoplay();
        });
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.videoVisibilityObserver) this.videoVisibilityObserver.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        if (this.heightFrame) cancelAnimationFrame(this.heightFrame);
        if (this.pageScrollFrame) cancelAnimationFrame(this.pageScrollFrame);
        if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
        if (this.autoplayFrame) cancelAnimationFrame(this.autoplayFrame);
        if (this.scrollSettleTimer) clearTimeout(this.scrollSettleTimer);
        if (this.autoplayInteractionTimer) clearTimeout(this.autoplayInteractionTimer);
        this.querySelectorAll('video').forEach((video) => video.pause());
        this.restorePageNavigation();
        this.isConnectedOnce = false;
      }

      initializeCardRails(signal) {
        this.cardRails.forEach((rail) => {
          rail.addEventListener('scroll', () => this.beginManualScroll(), { passive: true, signal });
          rail.addEventListener('scrollend', () => this.finishManualScroll(), { signal });
          rail.addEventListener('focusin', (event) => {
            if (!this.mobileCardsQuery.matches || !rail.hasAttribute('tabindex')) return;
            const card = event.target.closest('.spht__card');
            if (!card) return;

            card.scrollIntoView({
              behavior: this.reducedMotionQuery ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'nearest'
            });
          }, { signal });
        });
      }

      syncCardRailAccessibility() {
        this.cardRails.forEach((rail) => {
          const isScrollable = this.mobileCardsQuery.matches
            && rail.scrollWidth > rail.clientWidth + 1;

          if (isScrollable) {
            rail.tabIndex = 0;
            rail.setAttribute('aria-label', rail.dataset.sphtRailLabel || 'Product features');
          } else {
            rail.removeAttribute('tabindex');
            rail.removeAttribute('aria-label');
          }
        });
      }

      // 轮播始终可运行，忽略所有暂停条件
      canAutoplay() {
        return this.autoplayEnabled;
      }

      syncAutoplay() {
        if (!this.isConnected) return;

        if (this.autoplayFrame) cancelAnimationFrame(this.autoplayFrame);
        this.autoplayFrame = 0;
        this.autoplayLastTime = 0;
        this.renderAutoplayProgress();

        if (!this.canAutoplay()) {
          this.dataset.autoplayState = this.autoplayEnabled ? 'paused' : 'disabled';
          return;
        }

        this.dataset.autoplayState = 'running';
        this.autoplayLastTime = performance.now();
        this.autoplayFrame = requestAnimationFrame((time) => this.tickAutoplay(time));
      }

      tickAutoplay(time) {
        if (!this.canAutoplay()) {
          this.syncAutoplay();
          return;
        }

        const elapsedSinceLastFrame = Math.max(0, Math.min(500, time - this.autoplayLastTime));
        this.autoplayElapsed += elapsedSinceLastFrame;
        this.autoplayLastTime = time;
        this.renderAutoplayProgress();

        if (this.autoplayElapsed >= this.autoplayDuration) {
          this.autoplayFrame = 0;
          this.autoplayLastTime = 0;
          this.autoplayElapsed = 0;
          this.renderAutoplayProgress();

          const nextIndex = (this.activeIndex + 1) % this.panels.length;
          const animate = nextIndex !== 0;
          this.goTo(nextIndex, animate, 'autoplay');
          return;
        }

        this.autoplayFrame = requestAnimationFrame((nextTime) => this.tickAutoplay(nextTime));
      }

      resetAutoplayProgress(restart = true) {
        if (this.autoplayFrame) cancelAnimationFrame(this.autoplayFrame);
        this.autoplayFrame = 0;
        this.autoplayLastTime = 0;
        this.autoplayElapsed = 0;
        this.renderAutoplayProgress();
        if (restart) this.syncAutoplay();
      }

      renderAutoplayProgress() {
        const progress = this.autoplayEnabled
          ? Math.min(1, Math.max(0, this.autoplayElapsed / this.autoplayDuration))
          : 1;

        this.progressFills.forEach((fill, index) => {
          const value = index === this.activeIndex ? progress : 0;
          fill.style.transform = `scaleX(${value})`;
        });
      }

      onTrackInteractionStart() {
        this.cancelProgrammaticScroll();
        // 不暂停轮播
      }

      onTrackInteractionEnd() {
        // 不暂停轮播
      }

      onTrackWheel(event) {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        this.cancelProgrammaticScroll();
        this.beginManualScroll();
      }

      beginManualScroll() {
        if (!this.autoplayManualScrolling) {
          this.autoplayManualScrolling = true;
          // 不暂停轮播
        }

        if (this.autoplayInteractionTimer) clearTimeout(this.autoplayInteractionTimer);
        this.autoplayInteractionTimer = setTimeout(() => this.finishManualScroll(), 240);
      }

      finishManualScroll() {
        if (this.autoplayInteractionTimer) clearTimeout(this.autoplayInteractionTimer);
        this.autoplayInteractionTimer = 0;
        if (!this.autoplayManualScrolling) return;

        this.autoplayManualScrolling = false;
        // 不暂停轮播
      }

      onTrackScrollEnd() {
        if (this.programmaticIndex !== null) {
          this.finishProgrammaticScroll();
        } else {
          this.finishManualScroll();
        }
      }

      onTabKeydown(event, index) {
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        this.tabs[nextIndex].focus({ preventScroll: true });
        this.goTo(nextIndex, true, 'manual');
      }

      onTrackScroll() {
        if (this.programmaticIndex !== null) {
          if (this.scrollSettleTimer) clearTimeout(this.scrollSettleTimer);
          this.scrollSettleTimer = setTimeout(() => this.finishProgrammaticScroll(), 180);
          return;
        }

        this.beginManualScroll();

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);

        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          if (this.programmaticIndex !== null) return;

          const trackRect = this.track.getBoundingClientRect();
          const trackCenter = trackRect.left + (trackRect.width / 2);
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          this.panels.forEach((panel, index) => {
            const panelRect = panel.getBoundingClientRect();
            const panelCenter = panelRect.left + (panelRect.width / 2);
            const distance = Math.abs(panelCenter - trackCenter);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          if (closestIndex !== this.activeIndex) this.setActive(closestIndex, true);
        });
      }

      onBlockSelect(event) {
        const panel = event.target.closest('[data-spht-panel]');
        if (!panel || !this.contains(panel)) return;

        const index = this.panels.indexOf(panel);
        if (index > -1) this.goTo(index, false, 'manual');
      }

      goTo(index, animate, source = 'manual') {
        const panel = this.panels[index];
        if (!panel) return;

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = 0;
        if (source === 'manual') this.resetAutoplayProgress(false);
        this.programmaticIndex = index;
        if (this.scrollSettleTimer) clearTimeout(this.scrollSettleTimer);
        this.setActive(index, true);

        const trackRect = this.track.getBoundingClientRect();
        const panelRect = panel.getBoundingClientRect();
        const distance = panelRect.left - trackRect.left;

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: distance,
          behavior: animate && !prefersReducedMotion ? 'smooth' : 'auto'
        });

        if (!animate || prefersReducedMotion || Math.abs(distance) <= 1) {
          requestAnimationFrame(() => this.finishProgrammaticScroll());
        } else {
          this.scrollSettleTimer = setTimeout(() => this.finishProgrammaticScroll(), 800);
        }
      }

      finishProgrammaticScroll() {
        if (this.programmaticIndex === null) return;

        const index = this.programmaticIndex;
        const panel = this.panels[index];
        this.programmaticIndex = null;
        if (this.scrollSettleTimer) clearTimeout(this.scrollSettleTimer);
        this.scrollSettleTimer = 0;

        if (panel) {
          const trackRect = this.track.getBoundingClientRect();
          const panelRect = panel.getBoundingClientRect();
          const remainingDistance = panelRect.left - trackRect.left;

          if (Math.abs(remainingDistance) > 1) {
            this.track.scrollBy({ left: remainingDistance, behavior: 'auto' });
          }
        }

        this.setActive(index, true);
        // 不暂停轮播
      }

      cancelProgrammaticScroll() {
        if (this.programmaticIndex === null) return;

        this.track.scrollTo({ left: this.track.scrollLeft, behavior: 'auto' });
        this.programmaticIndex = null;
        if (this.scrollSettleTimer) clearTimeout(this.scrollSettleTimer);
        this.scrollSettleTimer = 0;
        this.onTrackScroll();
        // 不暂停轮播
      }

      setActive(index, centerNavigation) {
        if (!this.panels[index]) return;

        if (index === this.activeIndex) {
          if (centerNavigation) this.centerActiveTab(index);
          return;
        }

        this.activeIndex = index;
        this.resetAutoplayProgress(false);

        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === index;
          panel.setAttribute('aria-hidden', String(!isActive));
          if (isActive) {
            panel.removeAttribute('inert');
          } else {
            panel.setAttribute('inert', '');
          }
        });

        if (centerNavigation) this.centerActiveTab(index);
        this.updateHeight(index);
        this.syncVideos();
        // 关键修复：切换后重新启动轮播计时器，让进度条继续加载
        this.syncAutoplay();
      }

      centerActiveTab(index) {
        const tab = this.tabs[index];
        if (!tab || !this.navScroller) return;

        const scrollerRect = this.navScroller.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const distance = (tabRect.left + tabRect.width / 2) - (scrollerRect.left + scrollerRect.width / 2);

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.navScroller.scrollBy({
          left: distance,
          behavior: prefersReducedMotion ? 'auto' : 'smooth'
        });
      }

      updateHeight(index) {
        if (this.heightFrame) cancelAnimationFrame(this.heightFrame);

        this.heightFrame = requestAnimationFrame(() => {
          const panel = this.panels[index];
          if (!panel || !this.track) return;

          this.track.style.height = `${Math.ceil(panel.getBoundingClientRect().height)}px`;
        });
      }

      onViewportResize() {
        if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);

        this.resizeFrame = requestAnimationFrame(() => {
          this.goTo(this.activeIndex, false, 'system');
          this.syncCardRailAccessibility();
          this.schedulePageNavigationSync();
        });
      }

      schedulePageNavigationSync() {
        if (this.pageScrollFrame) cancelAnimationFrame(this.pageScrollFrame);

        this.pageScrollFrame = requestAnimationFrame(() => {
          this.syncPageNavigation();
          this.syncVideos();
        });
      }

      syncPageNavigation() {
        if (!this.stickyNav) return;

        const pageNavigation = document.querySelector('.anchor-nav-wrapper');
        if (!pageNavigation || this.contains(pageNavigation)) {
          this.style.removeProperty('--spht-page-anchor-offset');
          return;
        }

        if (this.dataset.hidePageAnchor !== 'true') {
          this.restorePageNavigation();
          this.style.setProperty('--spht-page-anchor-offset', `${pageNavigation.offsetHeight}px`);
          return;
        }

        this.style.removeProperty('--spht-page-anchor-offset');

        const sectionRect = this.getBoundingClientRect();
        const navigationRect = this.stickyNav.getBoundingClientRect();
        const stickyTop = Number.parseFloat(window.getComputedStyle(this.stickyNav).top) || 0;
        const takeoverDistance = pageNavigation.offsetHeight || navigationRect.height;
        const isApproachingStickyLine = navigationRect.top <= stickyTop + takeoverDistance;
        const localNavigationIsPresent = navigationRect.bottom > stickyTop && sectionRect.bottom > stickyTop;
        const shouldHide = isApproachingStickyLine && localNavigationIsPresent;

        if (shouldHide) {
          if (!pageNavigation.classList.contains('spht__page-anchor--hidden')) {
            pageNavigation.dataset.sphtHiddenBy = this.id;
            pageNavigation.dataset.sphtPreviousAriaHidden = pageNavigation.hasAttribute('aria-hidden')
              ? pageNavigation.getAttribute('aria-hidden')
              : '__missing__';
            pageNavigation.dataset.sphtHadInert = String(pageNavigation.hasAttribute('inert'));
            pageNavigation.classList.add('spht__page-anchor--hidden');
            pageNavigation.setAttribute('aria-hidden', 'true');
            pageNavigation.setAttribute('inert', '');
          }
        } else {
          this.restorePageNavigation();
        }
      }

      restorePageNavigation() {
        const pageNavigation = document.querySelector('.anchor-nav-wrapper');
        if (!pageNavigation || pageNavigation.dataset.sphtHiddenBy !== this.id) return;

        pageNavigation.classList.remove('spht__page-anchor--hidden');

        if (pageNavigation.dataset.sphtPreviousAriaHidden === '__missing__') {
          pageNavigation.removeAttribute('aria-hidden');
        } else {
          pageNavigation.setAttribute('aria-hidden', pageNavigation.dataset.sphtPreviousAriaHidden);
        }

        if (pageNavigation.dataset.sphtHadInert !== 'true') {
          pageNavigation.removeAttribute('inert');
        }

        delete pageNavigation.dataset.sphtHiddenBy;
        delete pageNavigation.dataset.sphtPreviousAriaHidden;
        delete pageNavigation.dataset.sphtHadInert;
      }

      initializeVideos(signal) {
        const showConfiguredControls = this.dataset.videoControls === 'true';
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.videos.forEach((video) => {
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.controls = prefersReducedMotion ? true : showConfiguredControls;

          video.addEventListener('pause', () => {
            if (this.automaticallyPausedVideos.has(video)) {
              this.automaticallyPausedVideos.delete(video);
              return;
            }

            video.dataset.sphtUserPaused = 'true';
          }, { signal });

          video.addEventListener('play', () => {
            if (this.automaticallyPlayedVideos.has(video)) {
              this.automaticallyPlayedVideos.delete(video);
              return;
            }

            delete video.dataset.sphtUserPaused;
            video.dataset.sphtUserStarted = 'true';
          }, { signal });
        });
      }

      updateVideoPreferences() {
        const showConfiguredControls = this.dataset.videoControls === 'true';
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.videos.forEach((video) => {
          video.controls = prefersReducedMotion ? true : showConfiguredControls;
        });
      }

      pauseVideo(video) {
        if (video.paused) return;

        this.automaticallyPausedVideos.add(video);
        video.pause();
        setTimeout(() => this.automaticallyPausedVideos.delete(video), 1000);
      }

      playVideo(video) {
        if (!video.paused) return;

        this.automaticallyPlayedVideos.add(video);
        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => this.automaticallyPlayedVideos.delete(video));
        }

        setTimeout(() => this.automaticallyPlayedVideos.delete(video), 1000);
      }

      syncVideos() {
        this.panels.forEach((panel, panelIndex) => {
          const isActivePanel = panelIndex === this.activeIndex;

          panel.querySelectorAll('video').forEach((video) => {
            if (!isActivePanel) {
              this.pauseVideo(video);
              return;
            }

            const isDisplayed = video.getClientRects().length > 0;
            const visibilityRatio = this.videoVisibilityRatios.get(video) || 0;
            const isMobileRailVideo = this.mobileCardsQuery.matches
              && Boolean(video.closest('[data-spht-card-rail]'));
            const minimumVisibility = isMobileRailVideo ? 0.55 : 0.2;
            const isEligible = !document.hidden && isDisplayed && visibilityRatio >= minimumVisibility;
            const userPaused = video.dataset.sphtUserPaused === 'true';
            const userStarted = video.dataset.sphtUserStarted === 'true';
            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            if (!isEligible) {
              this.pauseVideo(video);
            } else if (prefersReducedMotion) {
              if (!userStarted || userPaused) this.pauseVideo(video);
            } else if (userPaused) {
              this.pauseVideo(video);
            } else if (video.muted) {
              this.playVideo(video);
            }
          });
        });
      }
    }

    customElements.define('sihoo-highlight-tabs', SihooHighlightTabs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dhjdtv5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const ROOT_SELECTOR = '[data-nav-progress-v5]';
    const MANAGER_KEY = '__sihooNavProgressV5Manager';

    if (window[MANAGER_KEY]) {
      window[MANAGER_KEY].mountAll(document);
      return;
    }

    const instances = new WeakMap();

    function rootsWithin(scope) {
      if (!scope) return [];

      const roots = [];
      if (scope.nodeType === 1 && scope.matches && scope.matches(ROOT_SELECTOR)) {
        roots.push(scope);
      }
      if (scope.querySelectorAll) {
        scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => roots.push(root));
      }
      return Array.from(new Set(roots));
    }

    // 更新所有带 data-ratio-desk/data-ratio-mob 的容器的 aspect-ratio
    function updateAspectRatios() {
      const isMobile = window.innerWidth <= 1024;
      document.querySelectorAll('[data-ratio-desk][data-ratio-mob]').forEach(el => {
        const ratio = isMobile ? el.getAttribute('data-ratio-mob') : el.getAttribute('data-ratio-desk');
        if (ratio) {
          const [w, h] = ratio.split(':').map(Number);
          if (w && h) {
            el.style.aspectRatio = w / h;
          }
        }
      });
    }

    function createController(root) {
      const navContainer = root.querySelector('[data-v5-nav]');
      const navItems = Array.from(root.querySelectorAll('[data-v5-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-v5-panel]'));
      const indicator = root.querySelector('[data-v5-indicator]');
      const stageContainer = root.querySelector('[data-v5-stage]');
      const prevBtn = root.querySelector('[data-v5-nav-prev]');
      const nextBtn = root.querySelector('[data-v5-nav-next]');

      if (
        !navContainer ||
        !indicator ||
        !stageContainer ||
        !navItems.length ||
        navItems.length !== panels.length
      ) {
        console.warn('导航栏进度条 V5：导航项与内容面板数量不一致，已停止初始化。', root);
        return null;
      }

      const duration = Math.max(2000, Number(root.dataset.autoplayMs) || 5000);
      const totalTabs = navItems.length;
      const reducedMotionQuery = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : null;
      const eventController = new AbortController();
      const signal = eventController.signal;

      let currentIndex = navItems.findIndex((item) => item.classList.contains('active'));
      let elapsed = 0;
      let progressInterval = null;
      let layoutFrame = 0;
      let focusFrame = 0;
      let touchStart = null;
      let inViewport = true;
      let destroyed = false;

      if (currentIndex < 0) currentIndex = 0;

      // ———— 进度条更新：使用 setInterval 直接驱动 ————
      function updateProgressBar(ratio) {
        const percent = Math.max(0, Math.min(100, ratio * 100));
        const fill = document.querySelector('[data-v5-progress-fill]') || document.querySelector('.v5-autoplay-progress-fill');
        if (fill) {
          fill.style.width = percent + '%';
        }
      }

      function startProgressTimer() {
        if (progressInterval) clearInterval(progressInterval);
        if (totalTabs < 2) return;
        progressInterval = setInterval(() => {
          elapsed += 50; // 每 50ms 增加
          if (elapsed >= duration) {
            elapsed = 0;
            activate(currentIndex + 1, { resetProgress: true, scrollTab: true });
          } else {
            updateProgressBar(elapsed / duration);
          }
        }, 50);
      }

      function stopProgressTimer() {
        if (progressInterval) {
          clearInterval(progressInterval);
          progressInterval = null;
        }
      }

      function resetProgress() {
        elapsed = 0;
        updateProgressBar(0);
      }

      // 页面可见性变化时控制定时器
      function handleVisibilityChange() {
        if (document.hidden) {
          stopProgressTimer();
        } else if (!destroyed && totalTabs > 1) {
          startProgressTimer();
        }
      }

      function scheduleIndicatorUpdate() {
        if (destroyed) return;
        if (layoutFrame) window.cancelAnimationFrame(layoutFrame);

        layoutFrame = window.requestAnimationFrame(() => {
          layoutFrame = 0;
          const activeItem = navItems[currentIndex];
          if (!activeItem || !activeItem.isConnected) return;

          const navRect = navContainer.getBoundingClientRect();
          const itemRect = activeItem.getBoundingClientRect();
          const left = itemRect.left - navRect.left + navContainer.scrollLeft;

          indicator.style.width = itemRect.width + 'px';
          indicator.style.transform = 'translate3d(' + left + 'px, 0, 0)';
        });
      }

      function updateNavArrows() {
        if (!prevBtn || !nextBtn) return;

        const atStart = navContainer.scrollLeft <= 2;
        const atEnd = navContainer.scrollLeft + navContainer.clientWidth >= navContainer.scrollWidth - 2;

        prevBtn.classList.toggle('nav-arrow--hidden', atStart);
        nextBtn.classList.toggle('nav-arrow--hidden', atEnd);
      }

      function centerActiveTab(useSmoothScroll) {
        const activeItem = navItems[currentIndex];
        if (!activeItem) return;

        if (navContainer.scrollWidth <= navContainer.clientWidth + 2) return;

        const containerWidth = navContainer.clientWidth;
        const itemWidth = activeItem.offsetWidth;
        const itemLeft = activeItem.offsetLeft;

        const targetLeft = itemLeft - (containerWidth - itemWidth) / 2;
        const maxScroll = navContainer.scrollWidth - containerWidth;
        const clampedLeft = Math.max(0, Math.min(targetLeft, maxScroll));

        const reducedMotion = Boolean(reducedMotionQuery && reducedMotionQuery.matches);

        navContainer.scrollTo({
          left: clampedLeft,
          behavior: useSmoothScroll && !reducedMotion ? 'smooth' : 'auto'
        });

        setTimeout(updateNavArrows, 100);
      }

      function syncVideos() {
        const reduceMotion = Boolean(reducedMotionQuery && reducedMotionQuery.matches);

        panels.forEach((panel, panelIndex) => {
          panel.querySelectorAll('video').forEach((video) => {
            const shouldPlay =
              panelIndex === currentIndex &&
              inViewport &&
              !document.hidden &&
              !reduceMotion &&
              !destroyed;

            if (shouldPlay) {
              video.muted = true;
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            } else {
              video.pause();
            }
          });
        });
      }

      function activate(index, options) {
        const settings = options || {};
        const numericIndex = Number(index);
        if (!Number.isFinite(numericIndex)) return;

        const nextIndex = ((numericIndex % totalTabs) + totalTabs) % totalTabs;
        if (nextIndex === currentIndex) return;

        currentIndex = nextIndex;

        if (settings.resetProgress !== false) {
          resetProgress();
        }

        navItems.forEach((item, itemIndex) => {
          const active = itemIndex === currentIndex;
          item.classList.toggle('active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === currentIndex;
          panel.classList.toggle('active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) panel.removeAttribute('inert');
          else panel.setAttribute('inert', '');
        });

        scheduleIndicatorUpdate();
        syncVideos();

        if (settings.focusTab) {
          navItems[currentIndex].focus({ preventScroll: true });
        }
        if (settings.scrollTab) {
          requestAnimationFrame(() => {
            centerActiveTab(true);
          });
        }
      }

      function findTabIndex(tab) {
        return navItems.indexOf(tab);
      }

      function onRootClick(event) {
        const tab = event.target.closest
          ? event.target.closest('[data-v5-tab]')
          : null;
        if (!tab || !root.contains(tab)) return;

        const index = findTabIndex(tab);
        if (index < 0) return;
        event.preventDefault();
        // 点击时重置进度并切换
        resetProgress();
        activate(index, {
          resetProgress: true,
          scrollTab: true
        });
        // 重启定时器
        if (!document.hidden && totalTabs > 1) {
          stopProgressTimer();
          startProgressTimer();
        }
      }

      function onRootKeydown(event) {
        const tab = event.target.closest
          ? event.target.closest('[data-v5-tab]')
          : null;
        if (!tab || !root.contains(tab)) return;

        let nextIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = currentIndex + 1;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = currentIndex - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = totalTabs - 1;
        } else {
          return;
        }

        event.preventDefault();
        resetProgress();
        activate(nextIndex, {
          resetProgress: true,
          focusTab: true,
          scrollTab: true
        });
        if (!document.hidden && totalTabs > 1) {
          stopProgressTimer();
          startProgressTimer();
        }
      }

      // 触屏滑动
      function onTouchStart(event) {
        if (event.touches.length !== 1 || totalTabs < 2) return;
        const touch = event.touches[0];
        touchStart = {
          x: touch.clientX,
          y: touch.clientY,
          time: Date.now()
        };
        // 滑动时暂停定时器
        stopProgressTimer();
      }

      function onTouchEnd(event) {
        if (!touchStart || !event.changedTouches.length) {
          touchStart = null;
          if (!document.hidden && totalTabs > 1) startProgressTimer();
          return;
        }

        const touch = event.changedTouches[0];
        const dx = touch.clientX - touchStart.x;
        const dy = touch.clientY - touchStart.y;
        const elapsedTouch = Date.now() - touchStart.time;
        touchStart = null;

        const isSwipe =
          elapsedTouch <= 900 &&
          Math.abs(dx) >= 54 &&
          Math.abs(dx) > Math.abs(dy) * 1.25;

        if (isSwipe) {
          resetProgress();
          activate(currentIndex + (dx < 0 ? 1 : -1), {
            resetProgress: true,
            scrollTab: true
          });
        }
        if (!document.hidden && totalTabs > 1) startProgressTimer();
      }

      function onTouchCancel() {
        touchStart = null;
        if (!document.hidden && totalTabs > 1) startProgressTimer();
      }

      // 鼠标悬停暂停
      let hoverPaused = false;
      function onPointerEnter(event) {
        if (event.pointerType !== 'touch') {
          hoverPaused = true;
          stopProgressTimer();
        }
      }

      function onPointerLeave(event) {
        if (event.pointerType !== 'touch') {
          hoverPaused = false;
          if (!document.hidden && totalTabs > 1 && !hoverPaused) {
            startProgressTimer();
          }
        }
      }

      // 焦点暂停
      function syncFocusPause() {
        focusFrame = 0;
        const activeElement = document.activeElement;
        const isInside = Boolean(activeElement && root.contains(activeElement));
        if (isInside) {
          stopProgressTimer();
        } else if (!document.hidden && totalTabs > 1 && !hoverPaused) {
          startProgressTimer();
        }
      }

      function scheduleFocusPause() {
        if (focusFrame) window.cancelAnimationFrame(focusFrame);
        focusFrame = window.requestAnimationFrame(syncFocusPause);
      }

      // 箭头按钮
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          const firstItem = navContainer.querySelector('.nav-item');
          if (!firstItem) return;
          const gap = parseFloat(window.getComputedStyle(navContainer).gap) || 16;
          const scrollAmount = firstItem.offsetWidth + gap;
          navContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }, { signal: signal });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          const firstItem = navContainer.querySelector('.nav-item');
          if (!firstItem) return;
          const gap = parseFloat(window.getComputedStyle(navContainer).gap) || 16;
          const scrollAmount = firstItem.offsetWidth + gap;
          navContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }, { signal: signal });
      }

      root.addEventListener('click', onRootClick, { signal: signal });
      root.addEventListener('keydown', onRootKeydown, { signal: signal });
      root.addEventListener('pointerenter', onPointerEnter, { signal: signal });
      root.addEventListener('pointerleave', onPointerLeave, { signal: signal });
      root.addEventListener('focusin', scheduleFocusPause, { signal: signal });
      root.addEventListener('focusout', scheduleFocusPause, { signal: signal });
      stageContainer.addEventListener('touchstart', onTouchStart, {
        passive: true,
        signal: signal
      });
      stageContainer.addEventListener('touchend', onTouchEnd, {
        passive: true,
        signal: signal
      });
      stageContainer.addEventListener('touchcancel', onTouchCancel, {
        passive: true,
        signal: signal
      });
      window.addEventListener('resize', () => {
        scheduleIndicatorUpdate();
        updateNavArrows();
        updateAspectRatios();
      }, { passive: true, signal: signal });
      document.addEventListener('visibilitychange', handleVisibilityChange, {
        signal: signal
      });

      navContainer.addEventListener('scroll', updateNavArrows, {
        passive: true,
        signal: signal
      });

      if (reducedMotionQuery) {
        reducedMotionQuery.addEventListener('change', (e) => {
          if (e.matches) {
            stopProgressTimer();
          } else if (!document.hidden && totalTabs > 1) {
            startProgressTimer();
          }
        }, { signal: signal });
      }

      const intersectionObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            const entry = entries[0];
            const visible = entry.isIntersecting;
            inViewport = visible;
            if (!visible) {
              stopProgressTimer();
            } else if (!document.hidden && totalTabs > 1 && !hoverPaused) {
              startProgressTimer();
            }
            syncVideos();
          }, { threshold: 0.1 })
        : null;

      if (intersectionObserver) {
        intersectionObserver.observe(root);
      }

      const resizeObserver = 'ResizeObserver' in window
        ? new ResizeObserver(() => {
            scheduleIndicatorUpdate();
            if (!destroyed) {
              centerActiveTab(false);
              updateNavArrows();
            }
          })
        : null;

      if (resizeObserver) {
        resizeObserver.observe(navContainer);
        navItems.forEach((item) => resizeObserver.observe(item));
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (!destroyed) scheduleIndicatorUpdate();
        });
      }

      // 初始激活
      activate(currentIndex, {
        resetProgress: true,
        scrollTab: false
      });

      requestAnimationFrame(() => {
        centerActiveTab(false);
        updateNavArrows();
        updateAspectRatios();
        // 启动定时器
        if (!document.hidden && totalTabs > 1) {
          startProgressTimer();
        }
      });

      return {
        selectBlock(blockId) {
          const requestedId = String(blockId || '');
          const index = navItems.findIndex(
            (item) => item.dataset.blockId === requestedId
          );
          if (index >= 0) {
            resetProgress();
            activate(index, {
              resetProgress: true,
              scrollTab: true
            });
          }
        },

        setEditorPause(reason, shouldPause) {
          if (shouldPause) {
            stopProgressTimer();
          } else if (!document.hidden && totalTabs > 1) {
            startProgressTimer();
          }
        },

        refresh() {
          scheduleIndicatorUpdate();
          syncVideos();
          centerActiveTab(false);
          updateNavArrows();
          updateAspectRatios();
        },

        destroy() {
          if (destroyed) return;
          destroyed = true;
          stopProgressTimer();

          if (layoutFrame) window.cancelAnimationFrame(layoutFrame);
          if (focusFrame) window.cancelAnimationFrame(focusFrame);
          layoutFrame = 0;
          focusFrame = 0;

          eventController.abort();
          if (intersectionObserver) intersectionObserver.disconnect();
          if (resizeObserver) resizeObserver.disconnect();

          if (reducedMotionQuery) {
            reducedMotionQuery.removeEventListener('change', handleVisibilityChange);
          }

          panels.forEach((panel) => {
            panel.querySelectorAll('video').forEach((video) => video.pause());
          });
        }
      };
    }

    function mount(root) {
      if (!root || instances.has(root)) return;
      const controller = createController(root);
      if (controller) instances.set(root, controller);
    }

    function unmount(root) {
      if (!root) return;
      const controller = instances.get(root);
      if (controller) controller.destroy();
      instances.delete(root);
    }

    function mountAll(scope) {
      rootsWithin(scope).forEach(mount);
    }

    function unmountAll(scope) {
      rootsWithin(scope).forEach(unmount);
    }

    function controllersWithin(scope) {
      return rootsWithin(scope)
        .map((root) => ({
          root: root,
          controller: instances.get(root)
        }))
        .filter((entry) => Boolean(entry.controller));
    }

    const manager = {
      mountAll: mountAll,
      unmountAll: unmountAll
    };
    window[MANAGER_KEY] = manager;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => mountAll(document), {
        once: true
      });
    } else {
      mountAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      mountAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      unmountAll(event.target);
    });

    document.addEventListener('shopify:section:select', (event) => {
      controllersWithin(event.target).forEach((entry) => {
        entry.controller.setEditorPause('editor-section', true);
        entry.controller.refresh();
      });
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      controllersWithin(event.target).forEach((entry) => {
        entry.controller.setEditorPause('editor-section', false);
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const blockElement = event.target;
      const root = blockElement && blockElement.closest
        ? blockElement.closest(ROOT_SELECTOR)
        : null;
      const controller = root ? instances.get(root) : null;

      if (controller) {
        controller.selectBlock(event.detail && event.detail.blockId);
        controller.setEditorPause('editor-block', true);
      }
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const blockElement = event.target;
      const root = blockElement && blockElement.closest
        ? blockElement.closest(ROOT_SELECTOR)
        : null;
      const controller = root ? instances.get(root) : null;

      if (controller) {
        controller.setEditorPause('editor-block', false);
      }
    });

    document.addEventListener('shopify:section:reorder', (event) => {
      controllersWithin(event.target).forEach((entry) => {
        entry.controller.refresh();
      });
    });

    // 页面加载完成后，全局更新一次比例
    document.addEventListener('DOMContentLoaded', updateAspectRatios);
    window.addEventListener('resize', updateAspectRatios);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-bf-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sihoo-bf-countdown')) {
    class SihooBFCountdown extends HTMLElement {
      static get observedAttributes() {
        return ['data-end-date', 'data-end-time', 'data-utc-offset', 'data-expiry-mode', 'data-design-mode'];
      }

      connectedCallback() {
        this.stop();
        cancelAnimationFrame(this.frame);
        // Wait for children when an already-registered element is parsed or reinserted.
        this.frame = requestAnimationFrame(() => this.start());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.stop();
      }

      attributeChangedCallback(name, previous, next) {
        if (previous !== next && this.isConnected) this.connectedCallback();
      }

      getDeadline() {
        const date = /^(\d{4})-(\d{2})-(\d{2})$/.exec((this.dataset.endDate || '').trim());
        const time = /^(\d{2}):(\d{2})(?::(\d{2}))?$/.exec((this.dataset.endTime || '').trim());
        const offset = /^([+-])(\d{2}):(\d{2})$/.exec((this.dataset.utcOffset || '').trim());
        if (!date || !time || !offset) return NaN;

        const year = Number(date[1]);
        const month = Number(date[2]);
        const day = Number(date[3]);
        const hour = Number(time[1]);
        const minute = Number(time[2]);
        const second = Number(time[3] || 0);
        const offsetHours = Number(offset[2]);
        const offsetMinutes = Number(offset[3]);
        if (year < 1970 || hour > 23 || minute > 59 || second > 59 || offsetHours > 14 || offsetMinutes > 59 || (offsetHours === 14 && offsetMinutes !== 0)) return NaN;

        const local = Date.UTC(year, month - 1, day, hour, minute, second);
        const check = new Date(local);
        if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return NaN;
        const offsetTotal = (offsetHours * 60 + offsetMinutes) * (offset[1] === '+' ? 1 : -1);
        return local - offsetTotal * 60000;
      }

      start() {
        if (!this.isConnected) return;
        this.stop();
        this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-countdown-unit="' + unit + '"]'));
        this.grid = this.querySelector('[role="timer"]');
        if (!this.grid || this.units.some(unit => !unit)) return;
        this.deadline = this.getDeadline();
        const hint = this.querySelector('.sbf__countdown-hint');

        if (!Number.isFinite(this.deadline)) {
          this.hidden = this.dataset.designMode !== 'true';
          this.units.forEach(unit => { unit.textContent = '--'; });
          this.grid.setAttribute('aria-label', 'Countdown not configured');
          if (hint) hint.hidden = false;
          return;
        }

        if (hint) hint.hidden = true;
        this.hidden = false;
        if (!this.update()) return;
        this.interval = setInterval(() => this.update(), 1000);
        this.onVisibility = () => {
          if (!document.hidden) this.update();
        };
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      update() {
        if (!this.isConnected) {
          this.stop();
          return false;
        }
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        this.style.setProperty('--sbf-countdown-digits', String(Math.max(2, String(values[0]).length)));
        this.units.forEach((unit, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (unit.textContent !== value) unit.textContent = value;
        });
        this.grid.setAttribute('aria-label', values[0] + ' days, ' + values[1] + ' hours, ' + values[2] + ' minutes, ' + values[3] + ' seconds');
        this.hidden = remaining === 0 && this.dataset.expiryMode === 'hide';
        if (remaining === 0) this.stop();
        return remaining > 0;
      }

      stop() {
        clearInterval(this.interval);
        this.interval = null;
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        this.onVisibility = null;
      }
    }
    customElements.define('sihoo-bf-countdown', SihooBFCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-bf-benefit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pre-bf-benefit-countdown')) {
    customElements.define('pre-bf-benefit-countdown', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        window.cancelAnimationFrame(this.frame);
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          if (this.isConnected) this.start();
        });
      }

      start() {
        this.stop();
        this.digits = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-countdown-${unit}]`));
        if (this.digits.some(digit => !digit)) return;

        this.deadline = this.parseDeadline(this.dataset.deadline || '');
        const note = this.querySelector('[data-countdown-note]');
        if (note) note.hidden = Number.isFinite(this.deadline);

        if (!Number.isFinite(this.deadline)) {
          this.hidden = this.dataset.designMode !== 'true';
          this.digits.forEach(digit => { digit.textContent = '--'; });
          return;
        }

        if (this.update()) this.interval = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        this.stop();
        window.cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      stop() {
        window.clearInterval(this.interval);
        this.interval = null;
      }

      parseDeadline(value) {
        // An explicit UTC offset keeps the target identical for every visitor.
        const normalized = value.trim().replace(' ', 'T');
        const parts = normalized.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-](\d{2}):(\d{2}))$/);
        if (!parts) return NaN;
        const [, year, month, day, hours, minutes, seconds = '0', , offsetHours = '0', offsetMinutes = '0'] = parts;
        const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
        if (
          date.getUTCFullYear() !== Number(year) ||
          date.getUTCMonth() !== Number(month) - 1 ||
          date.getUTCDate() !== Number(day) ||
          Number(hours) > 23 || Number(minutes) > 59 || Number(seconds) > 59 ||
          Number(offsetHours) > 14 || Number(offsetMinutes) > 59 ||
          (Number(offsetHours) === 14 && Number(offsetMinutes) !== 0)
        ) return NaN;
        return Date.parse(normalized);
      }

      update() {
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        const values = [
          Math.floor(remaining / 86400),
          Math.floor(remaining % 86400 / 3600),
          Math.floor(remaining % 3600 / 60),
          remaining % 60
        ];
        this.digits.forEach((digit, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (digit.textContent !== value) digit.textContent = value;
        });
        this.hidden = remaining === 0 && this.dataset.expiry === 'hide';
        if (remaining === 0) this.stop();
        return remaining > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-bf-free-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pre-bf-free-order')) {
    class PreBfFreeOrder extends HTMLElement {
      // One shared lock for all instances, including simultaneous modal dialogs.
      static scrollOwners = new Set();
      static previousOverflow = '';
      static previousOverflowPriority = '';

      connectedCallback() {
        this.onClick = this.handleClick.bind(this);
        this.onClose = this.handleClose.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('close', this.onClose, true);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('close', this.onClose, true);
        const dialog = this.querySelector('dialog');
        if (dialog && dialog.open) dialog.close();
        this.unlockScroll();
        this.opener = null;
      }

      handleClick(event) {
        const dialog = this.querySelector('dialog');
        if (!dialog) return;
        const opener = event.target.closest('[data-rules-open]');
        if (opener) {
          if (dialog.open) return;
          this.opener = opener;
          dialog.showModal();
          this.lockScroll();
          return;
        }
        if (event.target.closest('[data-rules-close]')) {
          dialog.close();
          return;
        }
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            dialog.close();
          }
        }
      }

      handleClose(event) {
        if (!event.target.matches('.pbfo__dialog') || event.target.open) return;
        this.unlockScroll();
        if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }

      lockScroll() {
        const owners = PreBfFreeOrder.scrollOwners;
        if (owners.has(this)) return;
        if (owners.size === 0) {
          const style = document.documentElement.style;
          PreBfFreeOrder.previousOverflow = style.getPropertyValue('overflow');
          PreBfFreeOrder.previousOverflowPriority = style.getPropertyPriority('overflow');
          style.setProperty('overflow', 'hidden', 'important');
        }
        owners.add(this);
      }

      unlockScroll() {
        const owners = PreBfFreeOrder.scrollOwners;
        if (!owners.delete(this) || owners.size > 0) return;
        const style = document.documentElement.style;
        if (PreBfFreeOrder.previousOverflow) {
          style.setProperty('overflow', PreBfFreeOrder.previousOverflow, PreBfFreeOrder.previousOverflowPriority);
        } else {
          style.removeProperty('overflow');
        }
      }
    }
    customElements.define('pre-bf-free-order', PreBfFreeOrder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-bf-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pre-bf-v2')) {
    customElements.define('pre-bf-v2', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.panels = Array.from(this.querySelectorAll('[data-desktop-panel]'));
        this.accordion = this.querySelector('[data-accordion]');
        this.accordionItems = Array.from(this.querySelectorAll('[data-accordion-item]'));
        this.desktopHotspots = Array.from(this.querySelectorAll('[data-desktop-hotspot]'));
        this.availableDesktop = this.desktopHotspots.filter(button => !button.disabled).map(button => button.dataset.blockId);
        this.mobileHotspots = Array.from(this.querySelectorAll('[data-mobile-hotspot]'));
        this.desktopNext = this.querySelector('[data-desktop-next]');
        this.status = this.querySelector('[data-status]');
        this.desktopCurrent = null;
        this.lastDesktopTrigger = null;
        this.lastMobileTrigger = null;
        this.modal = document.getElementById(this.dataset.modalId);
        if (this.modal) {
          document.body.appendChild(this.modal);
          this.modalIsPortaled = true;
          this.modalPanel = this.modal.querySelector('[data-modal-panel]');
          this.modalScroll = this.modal.querySelector('[data-modal-scroll]');
          this.modalFeatures = Array.from(this.modal.querySelectorAll('[data-modal-feature]'));
          this.modalCount = this.modal.querySelector('[data-modal-count]');
          this.modalCurrent = null;
          this.availableMobile = this.mobileHotspots.filter(button => !button.disabled).map(button => button.dataset.blockId);
          this.modal.querySelector('[data-modal-prev]')?.addEventListener('click', () => this.stepModal(-1), opts);
          this.modal.querySelector('[data-modal-next]')?.addEventListener('click', () => this.stepModal(1), opts);
          this.modal.querySelector('[data-modal-close]')?.addEventListener('click', () => this.closeModal(), opts);
          this.modal.addEventListener('click', event => {
            if (event.target === this.modal) this.closeModal();
          }, opts);

          let touchStart = null;
          this.modalScroll?.addEventListener('touchstart', event => {
            if (event.touches.length !== 1 || event.target.closest('video, a, button')) {
              touchStart = null;
              return;
            }
            touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
          }, { ...opts, passive: true });
          this.modalScroll?.addEventListener('touchend', event => {
            if (!touchStart || !event.changedTouches.length) return;
            const dx = event.changedTouches[0].clientX - touchStart.x;
            const dy = event.changedTouches[0].clientY - touchStart.y;
            touchStart = null;
            if (Math.abs(dx) >= 55 && Math.abs(dx) > Math.abs(dy) * 1.35) {
              this.stepModal(dx < 0 ? 1 : -1);
            }
          }, { ...opts, passive: true });
          this.modalScroll?.addEventListener('touchcancel', () => { touchStart = null; }, opts);
        }

        this.selectDesktop(null, false);
        this.addEventListener('click', event => {
          const pcHotspot = event.target.closest('[data-desktop-hotspot]');
          if (pcHotspot && !pcHotspot.disabled) {
            this.lastDesktopTrigger = pcHotspot;
            this.selectDesktop(pcHotspot.dataset.blockId);
            this.accordionItems.find(item => item.dataset.blockId === pcHotspot.dataset.blockId)
              ?.querySelector('[data-accordion-button]')?.focus({ preventScroll: true });
            return;
          }
          const accordionButton = event.target.closest('[data-accordion-button]');
          if (accordionButton && !accordionButton.disabled) {
            // The selected card's minus/header returns to the product overview.
            this.returnToCover();
            return;
          }
          if (event.target.closest('[data-desktop-next]')) {
            this.stepDesktop();
            return;
          }
          const mobileHotspot = event.target.closest('[data-mobile-hotspot]');
          if (mobileHotspot && !mobileHotspot.disabled) this.openModal(mobileHotspot.dataset.blockId, mobileHotspot);
        }, opts);

        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.desktopCurrent && !this.mobileQuery.matches) {
            event.preventDefault();
            this.returnToCover();
            return;
          }
          const button = event.target.closest('[data-accordion-button]');
          if (!button || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          const enabled = Array.from(this.querySelectorAll('[data-accordion-button]:not(:disabled)'));
          const index = enabled.indexOf(button);
          if (index < 0 || !enabled.length) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = enabled.length - 1;
          else nextIndex = (index + (event.key === 'ArrowDown' ? 1 : -1) + enabled.length) % enabled.length;
          this.selectDesktop(enabled[nextIndex].dataset.blockId);
          enabled[nextIndex].focus({ preventScroll: true });
        }, opts);

        document.addEventListener('keydown', event => {
          if (!this.modal || this.modal.hidden) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.closeModal();
          } else if (event.key === 'Tab') {
            this.trapModalFocus(event);
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
            event.preventDefault();
            this.stepModal(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, opts);
        this.addEventListener('shopify:block:select', event => {
          const blockId = event.detail?.blockId;
          if (!blockId || !this.panels.some(panel => panel.dataset.blockId === blockId)) return;
          if (this.mobileQuery.matches) {
            const trigger = this.mobileHotspots.find(button => button.dataset.blockId === blockId);
            if (trigger && !trigger.disabled) this.openModal(blockId, trigger);
          } else {
            this.selectDesktop(blockId);
          }
        }, opts);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauseAllVideos();
        }, opts);
        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', () => {
            if (!this.mobileQuery.matches) this.closeModal(true);
            else this.selectDesktop(null, false);
          }, opts);
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (!entries[0]?.isIntersecting) this.pauseDesktopVideos();
          });
          this.observer.observe(this);
        }
      }

      selectDesktop(blockId, announce = true) {
        const panel = this.panels.find(item => item.dataset.blockId === blockId);
        this.pauseDesktopVideos();
        this.desktopCurrent = panel ? blockId : null;
        const hasMedia = Boolean(panel && panel.dataset.hasMedia === 'true');
        this.toggleAttribute('data-feature-active', Boolean(panel));
        this.toggleAttribute('data-feature-media-active', hasMedia);
        this.panels.forEach(item => { item.hidden = !hasMedia || item !== panel; });
        if (this.accordion) {
          this.accordion.hidden = !panel;
          this.accordion.scrollTop = 0;
        }
        if (this.desktopNext) this.desktopNext.hidden = !panel || this.availableDesktop.length < 2;
        this.accordionItems.forEach(item => {
          const active = Boolean(panel && item.dataset.blockId === blockId);
          item.hidden = !active;
          item.classList.toggle('is-active', active);
          const button = item.querySelector('[data-accordion-button]');
          const content = item.querySelector('[data-accordion-description]');
          if (button) button.setAttribute('aria-expanded', String(active));
          if (content) content.hidden = !active;
        });
        if (announce && this.status) {
          const button = this.accordionItems.find(item => item.dataset.blockId === blockId)?.querySelector('[data-accordion-button]');
          this.status.textContent = panel ? (button?.textContent || 'Feature').trim() : 'Back to overview';
        }
        const video = panel?.querySelector('video');
        if (video && !document.hidden && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.play()?.catch(() => {});
        }
      }

      stepDesktop() {
        if (this.mobileQuery.matches || !this.desktopCurrent || this.availableDesktop.length < 2) return;
        const index = this.availableDesktop.indexOf(this.desktopCurrent);
        const next = (index + 1) % this.availableDesktop.length;
        this.selectDesktop(this.availableDesktop[next]);
      }

      returnToCover() {
        this.selectDesktop(null);
        if (this.lastDesktopTrigger?.isConnected) this.lastDesktopTrigger.focus({ preventScroll: true });
      }

      openModal(blockId, trigger) {
        if (!this.mobileQuery?.matches || !this.modal || !this.availableMobile.includes(blockId)) return;
        if (this.closeTimer) clearTimeout(this.closeTimer);
        const wasHidden = this.modal.hidden;
        if (wasHidden || !this.modal.classList.contains('is-open')) {
          this.lastMobileTrigger = trigger || null;
          this.modal.hidden = false;
          this.lockScroll();
        }
        this.showModalFeature(blockId, 1);
        requestAnimationFrame(() => {
          if (!this.modal || this.modal.hidden) return;
          this.modal.classList.add('is-open');
          if (wasHidden) this.modalPanel?.focus({ preventScroll: true });
        });
      }

      showModalFeature(blockId, direction) {
        const feature = this.modalFeatures?.find(item => item.dataset.blockId === blockId);
        if (!feature) return;
        this.pauseModalVideos();
        this.modalCurrent = blockId;
        this.modal.dataset.direction = direction < 0 ? 'prev' : 'next';
        this.modalFeatures.forEach(item => {
          item.hidden = item !== feature;
          item.classList.remove('is-entering');
        });
        feature.classList.add('is-entering');
        this.modal.setAttribute('aria-labelledby', feature.querySelector('.pbv__modal-title')?.id || '');
        const index = this.availableMobile.indexOf(blockId);
        if (this.modalCount) this.modalCount.textContent = `${index + 1} / ${this.availableMobile.length}`;
        if (this.modalScroll) this.modalScroll.scrollTop = 0;
        if (this.status) this.status.textContent = feature.querySelector('.pbv__modal-title')?.textContent?.trim() || 'Product feature';
        const video = feature.querySelector('video');
        if (video && !document.hidden && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.play()?.catch(() => {});
        }
      }

      stepModal(step) {
        if (!this.modal || this.modal.hidden || !this.availableMobile.length) return;
        const index = this.availableMobile.indexOf(this.modalCurrent);
        const next = (Math.max(0, index) + step + this.availableMobile.length) % this.availableMobile.length;
        this.showModalFeature(this.availableMobile[next], step);
      }

      closeModal(immediate = false) {
        if (!this.modal || this.modal.hidden) return;
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.modal.classList.remove('is-open');
        this.pauseModalVideos();
        this.unlockScroll();
        const trigger = this.lastMobileTrigger;
        if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.modal.hidden = true;
          if (!immediate && trigger?.isConnected) trigger.focus({ preventScroll: true });
        } else {
          this.closeTimer = window.setTimeout(() => {
            if (this.modal) this.modal.hidden = true;
            if (trigger?.isConnected && this.mobileQuery.matches) trigger.focus({ preventScroll: true });
            this.closeTimer = null;
          }, 180);
        }
        this.lastMobileTrigger = null;
      }

      lockScroll() {
        if (this.scrollLocked) return;
        this.previousOverflow = document.body.style.overflow;
        this.previousPaddingRight = document.body.style.paddingRight;
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
        this.scrollLocked = true;
      }
      unlockScroll() {
        if (!this.scrollLocked) return;
        document.body.style.overflow = this.previousOverflow;
        document.body.style.paddingRight = this.previousPaddingRight;
        this.scrollLocked = false;
      }
      trapModalFocus(event) {
        const nodes = Array.from(this.modal.querySelectorAll('button:not(:disabled), a[href], [tabindex]:not([tabindex="-1"])'));
        const focusable = nodes.filter(node => !node.closest('[hidden]') && node.getClientRects().length);
        if (!focusable.length) { event.preventDefault(); this.modalPanel?.focus(); return; }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.modalPanel)) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
      pauseDesktopVideos() { this.panels?.forEach(panel => panel.querySelectorAll('video').forEach(video => video.pause())); }
      pauseModalVideos() { this.modal?.querySelectorAll('video').forEach(video => video.pause()); }
      pauseAllVideos() { this.pauseDesktopVideos(); this.pauseModalVideos(); }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.pauseAllVideos();
        this.unlockScroll();
        if (this.modalIsPortaled) this.modal?.remove();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-page-popup-link"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pre-page-popup-link')) {
    class PrePagePopupLink extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.floating = this.querySelector('[data-ppl-floating]');
        this.link = this.querySelector('[data-ppl-link]');
        this.minimizeButton = this.querySelector('[data-ppl-minimize]');
        if (!this.floating || !this.link) return;

        // Extra same-page protection for an absolute URL with a different
        // www/non-www spelling. Normal relative links are filtered in Liquid.
        try {
          const destination = new URL(this.link.href);
          const current = new URL(window.location.href);
          const host = (value) => value.replace(/^www\./i, '');
          const path = (value) => value.replace(/\/+$/, '') || '/';
          if (host(destination.hostname) === host(current.hostname) &&
              path(destination.pathname) === path(current.pathname)) {
            this.style.display = 'none';
            return;
          }
        } catch (error) {
          // The native anchor remains responsible for resolving the URL.
        }

        // Remember minimized state across storefront pages within this tab.
        if (this.minimizeButton && (!window.Shopify || !window.Shopify.designMode)) {
          try {
            if (sessionStorage.getItem(this.dataset.storageKey) === 'minimized') {
              this.floating.classList.add('is-minimized');
            }
          } catch (error) {
            // Storage may be unavailable in private browsing environments.
          }
        }

        this._onMinimize = () => {
          this.floating.classList.add('is-minimized');
          try {
            sessionStorage.setItem(this.dataset.storageKey, 'minimized');
          } catch (error) {
            // The UI still minimizes when storage is unavailable.
          }
          this.link.focus({ preventScroll: true });
        };
        if (this.minimizeButton) {
          this.minimizeButton.addEventListener('click', this._onMinimize);
        }

        this._onScroll = () => {
          if (this._visibilityFrame) return;
          this._visibilityFrame = requestAnimationFrame(() => this.syncVisibility());
        };
        if (this.dataset.triggerMode === 'scroll') {
          window.addEventListener('scroll', this._onScroll, { passive: true });
        }
        this.syncVisibility();
      }

      disconnectedCallback() {
        if (this.minimizeButton && this._onMinimize) {
          this.minimizeButton.removeEventListener('click', this._onMinimize);
        }
        if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
        if (this._visibilityFrame) cancelAnimationFrame(this._visibilityFrame);
        this._visibilityFrame = null;
        this._initialized = false;
      }

      syncVisibility() {
        this._visibilityFrame = null;
        if (!this.floating) return;
        if (this.dataset.triggerMode !== 'scroll') {
          this.floating.classList.add('is-visible');
          return;
        }
        const threshold = Number(this.dataset.scrollThreshold) || 0;
        this.floating.classList.toggle('is-visible', window.scrollY >= threshold);
      }
    }
    customElements.define('pre-page-popup-link', PrePagePopupLink);
  }

  } catch(e) { console.error(e); }
})();
})();
